/**
 * UGREEN AI NAS - 优化后的动画脚本
 * 使用GSAP和ScrollTrigger实现滚动触发动画
 */

// GSAP插件注册将在初始化时进行

// 主应用对象 - 组织所有功能
const UGreenAINAS = {
    // DOM元素缓存
    elements: {},
    
    // 动画时间线缓存
    timelines: {},
    
    // 配置项
    config: {
        animationDuration: 0.8,
        staggerDelay: 0.1,
        easeDefault: "power2.out",
        easeBack: "back.out(1.7)"
    },

    /**
     * 初始化应用
     */
        init() {
        try {
            // 设置全局引用以便在swiper回调中使用
            document.ugaiNasInstance = this;
            window.UGAINas = this;
            
            // 检查关键DOM元素是否存在
            if (!this._checkRequiredElements()) {
                setTimeout(() => this.init(), 500);
                return;
            }
        
        // 首先复制PC导航到移动端导航
        this.copyPcNavToMobileNav();
        
        // 初始化移动端导航功能
        this.initMobileNavigation();
        
        // 初始化导航粘性效果
        this.initStickyNavigation();
        
        this.cacheElements();
        this.setupEventListeners();
        this.initVideoHandlers();
        this.initSimplifiedSetup();

        this.initSubscribeForm();
        this.initSecAllDayAnimations();
        this.initUGAllDayAnimations();
        this.initSuperSmoothMultitaskingAnimations();
        this.initIntelligentConversationFeatures();

        this.ga4TrackAddClick();
        this.positionFn();
        
            // 延迟初始化确保DOM完全加载和渲染
        setTimeout(() => {
            this.initAnimations();
                this.initSwipers();
                
                // 确保ScrollTrigger最后刷新
                if (window.ScrollTrigger) {
            ScrollTrigger.refresh();
                }
                

            }, 150);
            
        } catch (error) {
            // 错误情况下重试
            setTimeout(() => this.init(), 1000);
        }
    },

    /**
     * 检查必需的DOM元素是否存在
     */
    _checkRequiredElements() {
        const requiredSelectors = [
            'body',
            'head'
        ];
        
        return requiredSelectors.every(selector => {
            const element = document.querySelector(selector);
            if (!element) {
                return false;
            }
            return true;
        });
    },

    /**
     * 重新初始化特定组件
     */
    reinitializeComponent(componentName) {
        try {
            const componentMethods = {
                'animations': () => this.initAnimations(),
                'swipers': () => this.initSwipers(),
                'navigation': () => {
                    this.initMobileNavigation();
                    this.initStickyNavigation();
                },
                'events': () => this.setupEventListeners(),
                'videos': () => this.initVideoHandlers(),
                'fastDataTransfer': () => this.initFastDataTransferAnimations(),
                'simplifiedSetup': () => this.initSimplifiedSetupAnimations(),
                'criticalAnimations': () => {
                    this.initFastDataTransferAnimations();
                    this.initSimplifiedSetupAnimations();
                }
            };
            
            if (componentMethods[componentName]) {
                componentMethods[componentName]();
                
                // 刷新ScrollTrigger
                if (window.ScrollTrigger) {
                    ScrollTrigger.refresh();
                }
            }
            
        } catch (error) {
            // 静默处理错误
        }
    },

    // 跳转定位
    positionFn(){
      // 定位跳转
      let clickList = document.querySelectorAll('.idx-nas-new-positionFn');
      clickList.forEach((item,index)=>{
        item.addEventListener('click',()=>{
          let scrollDiv = item.getAttribute('data-scrolldiv');
          scrollDiv = document.querySelector(`.${scrollDiv}`);
          if(!scrollDiv){
            return false;
          }
          let cjJL = 0;
          if(window.innerWidth > 768){
            if(item.getAttribute('data-pcJL')){
              cjJL = item.getAttribute('data-pcJL');
            }
          }else{
            if(item.getAttribute('data-moJL')){
              cjJL = item.getAttribute('data-moJL');
            }
          }

          let scrolljl = document.documentElement.scrollTop || document.body.scrollTop;
          let contentScrollJL = 0;
          contentScrollJL = scrollDiv.getBoundingClientRect().top - cjJL + scrolljl  - 10 + 1;
          if(contentScrollJL <= 0){
            contentScrollJL = 0;
          }
          window.scrollTo({
            top: contentScrollJL,
            behavior: "smooth"
          });

        });
      });
    },
    // ga4 上传
    ga4TrackAddClick(){
      let buttonList = document.querySelectorAll('.ug-button-ga4');
      buttonList.forEach((item,key)=>{
        if(!window.ugGa4Track){
          return false;
        }
        //ga4ButtonName button：功能描述
        item.addEventListener('click',()=>{
          let ga4ButtonName = item.getAttribute('data-ga4ButtonName');
          let ga4Position = window.brandDataObj?.ga4Position || `brand-day`;
          window.ugGa4Track.clickEvent({button_name: ga4ButtonName, position: `${ga4Position}`});
        });
      });
    },

     /**
     * 复制PC导航内容到移动端导航
     */
     copyPcNavToMobileNav() {
        const pcNavSection = document.querySelector('.idx-nas-new-pc-nav');
        const mobileNavSection = document.querySelector('.idx-nas-new-mobile-nav');
        
        if (pcNavSection && mobileNavSection) {
            // 只复制需要的导航内容，排除占位元素
            const pcNavAllSection = pcNavSection.querySelector('.idx-nas-new-navAll');
            
            // 清空移动端导航的现有内容
            mobileNavSection.innerHTML = '';
            
            if (pcNavAllSection) {
                // 只复制导航内容，而不是整个容器
                const clonedElement = pcNavAllSection.cloneNode(true);
                mobileNavSection.appendChild(clonedElement);
            }
        }
    },

    /**
     * 初始化导航粘性滚动效果
     */
    initStickyNavigation() {
        const pcNavSection = document.querySelector('.idx-nas-new-pc-nav');
        const mobileNavSection = document.querySelector('.idx-nas-new-mobile-nav');
        
        // 为PC导航添加粘性效果
        if (pcNavSection) {
            this.createStickyNavEffect(pcNavSection, 'pc-nav-sticky');
        }
        
        // 为移动端导航添加粘性效果
        if (mobileNavSection) {
            this.createStickyNavEffect(mobileNavSection, 'mobile-nav-sticky');
        }
    },

    /**
     * 创建粘性导航效果
     */
    createStickyNavEffect(navElement, triggerName) {
        let navOffsetTop = 0;
        let navHeight = 0;
        let isSticky = false;
        let scrollTriggerInstance = null;
        let navAllElement = null;
        let originalNavAllStyles = {};
        
        // 查找内部的 navAll 元素
        navAllElement = navElement.querySelector('.idx-nas-new-navAll');
        if (!navAllElement) {
            return;
        }
        
        // 初始化或重新计算尺寸和位置的函数
        const initOrUpdateDimensions = () => {
            // 临时重置navAll元素样式以获取正确位置
            if (isSticky) {
                gsap.set(navAllElement, originalNavAllStyles);
                isSticky = false;
            }
            
            // 强制重绘
            navElement.offsetHeight;
            
            // 获取导航元素的位置和尺寸
            const navRect = navElement.getBoundingClientRect();
            navOffsetTop = navRect.top + window.scrollY;
            navHeight = navRect.height;
            
            // 保存navAll元素的原始样式
            originalNavAllStyles = {
                position: '',
                top: '',
                left: '',
                right: '',
                zIndex: '',
                width: ''
            };
            
            // 不创建占位元素，不添加任何高度撑开
            // 粘性导航切换时直接显示，不需要额外的空间补偿
            
            // 立即检查当前滚动状态并应用
            updateStickyState();
            
            // 尺寸已更新
        };
        
        // 滚动更新函数
        const updateStickyState = () => {
            const scrollY = window.scrollY;
            const shouldBeSticky = scrollY >= navOffsetTop;
            
            if (shouldBeSticky && !isSticky) {
                // 直接切换到粘性状态 - 对navAll元素应用fixed样式
                isSticky = true;
                
                gsap.set(navAllElement, {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1000,
                    width: '100%'
                });
                
            } else if (!shouldBeSticky && isSticky) {
                // 直接切换回原始状态
                isSticky = false;
                
                gsap.set(navAllElement, originalNavAllStyles);
            }
        };
        
        // 防抖的resize处理函数
        const debouncedResize = this.debounce(() => {
            // 重新初始化尺寸
            initOrUpdateDimensions();
            
            // 刷新ScrollTrigger而不是重新创建
            if (scrollTriggerInstance) {
                setTimeout(() => {
                    scrollTriggerInstance.refresh();
                }, 50);
            }
        }, 100);
        
        // 延迟执行确保DOM完全渲染
        setTimeout(() => {
            // 初始化
            initOrUpdateDimensions();
            
            // 延迟创建ScrollTrigger，确保初始化完成
            setTimeout(() => {
                scrollTriggerInstance = ScrollTrigger.create({
                    trigger: navElement,
                    start: "top top",
                    end: "bottom bottom",
                    onUpdate: updateStickyState
                });
                
            }, 50);
            
            // 监听resize事件
            window.addEventListener('resize', debouncedResize);
        }, 100);
    },

    /**
     * 缓存DOM元素 - 避免重复查询
     */
    cacheElements() {
        this.elements = {
            // Purchase Section
            purchaseSection: document.querySelector('.ug-ai-nas__purchase-section'),
            purchaseHeader: document.querySelector('.ug-ai-nas__purchase-header'),
            purchaseTitleGroup: document.querySelector('.ug-ai-nas__purchase-title-group'),
            dividerLines: document.querySelectorAll('.ug-ai-nas__divider-line'),
            
            // Success Section
            successTitle: document.querySelector('.ug-ai-nas__success-title'),
            statCards: document.querySelectorAll('.ug-ai-nas__stat-card'),

            successSection: document.querySelector('.ug-ai-nas__success-section'),
            
            // Modal
            modal: document.getElementById('purchaseModal'),
            modalCloseBtn: document.getElementById('modalCloseBtn'),
            
            // What is NAS Modal
            nasModal: document.getElementById('whatIsNasModal'),
            nasModalCloseBtn: document.getElementById('nasModalCloseBtn'),
            nasComparisonContainer: document.querySelector('.ug-ai-nas__comparison-containerdiv'),
            
            // Smart Connectivity Section
            smartConnectivitySection: document.querySelector('.ug-ai-nas__smart-connectivity-section'),
            smartConnectivityContainer: document.querySelector('.ug-ai-nas__smart-connectivity-container'),
            smartConnectivityBg: document.querySelector('.ug-ai-nas__smart-connectivity-bg'),
            smartConnectivityContent: document.querySelector('.ug-ai-nas__smart-connectivity-content'),
            smartConnectivityCards: document.querySelectorAll('.ug-ai-nas__smart-connectivity-content-item-card'),
            smartConnectivityCardTitles: document.querySelectorAll('.ug-ai-nas__smart-connectivity-content-item-card-content-title'),
            smartConnectivityCardSubtitles: document.querySelectorAll('.ug-ai-nas__smart-connectivity-content-item-card-content-subtitle'),
            smartConnectivityCardDescs: document.querySelectorAll('.ug-ai-nas__smart-connectivity-content-item-card-content-desc'),
            
            // Fast Data Transfer Section
            fastDataTransferSection: document.querySelector('.ug-ai-nas__fast-data-transfer-section'),
            fastDataTransferContainers: document.querySelectorAll('.ug-ai-nas__fast-data-transfer-container'),
            fastDataTransferSubtitles: document.querySelectorAll('.ug-ai-nas__fast-data-transfer-content-subtitle'),
            fastDataTransferTitles: document.querySelectorAll('.ug-ai-nas__fast-data-transfer-content-title'),
            fastDataTransferNumberItems: document.querySelectorAll('.ug-ai-nas__fast-data-transfer-content-number-content-item'),
            fastDataTransferProgressBars: document.querySelectorAll('.ug-ai-nas__fast-data-transfer-content-number-content-number-line-progress'),
            fastDataTransferDescs: document.querySelectorAll('.ug-ai-nas__fast-data-transfer-desc'),
            fastDataTransferDescLists: document.querySelectorAll('.ug-ai-nas__fast-data-transfer-desc-list'),
            
            // Security Section
            securitySection: document.querySelector('.ug-ai-nas__security-section'),
            securityStickyContainer: document.querySelector('.ug-ai-nas__security-sticky-container'),
            securityBg: document.querySelector('.ug-ai-nas__security-bg'),
            securityBgImg: document.querySelector('.ug-ai-nas__security-bg-img'),
            securityBgIcon: document.querySelector('.ug-ai-nas__security-bg-icon'),
            securityContent: document.querySelector('.ug-ai-nas__security-content'),
            securityTitle: document.querySelector('.ug-ai-nas__security-title'),
            securityFeatures: document.querySelector('.ug-ai-nas__security-features'),
            securityCards: document.querySelectorAll('.ug-ai-nas__security-card'),
            deviceImg: document.querySelector('.ug-ai-nas__device-img'),
            securityBadges: document.querySelectorAll('.ug-ai-nas__badge'),
            
            // Service Section
            serviceSection: document.querySelector('.ug-ai-nas__service-section'),
            serviceTitles: document.querySelectorAll('.ug-ai-nas__service-title'),
            serviceCards: document.querySelectorAll('.ug-ai-nas__service-card'),
            qualityStats: document.querySelectorAll('.ug-ai-nas__quality-stat'),
            
            // Cooling Section
            coolingSection: document.querySelector('.ug-ai-nas__cooling-section'),
            coolingContainers: document.querySelectorAll('.ug-ai-nas__cooling-container'),
            coolingTexts: document.querySelectorAll('.ug-ai-nas__cooling-text'),
            coolingChange: document.querySelector('.ug-ai-nas__cooling-change'),
            coolingChangeItems: document.querySelectorAll('.ug-ai-nas__cooling-change-item'),
            coolingBgImages: document.querySelectorAll('.ug-ai-nas__cooling-bg-img'),

            // Simplified Setup Section
            simplifiedSetupSection: document.querySelector('.ug-ai-nas__simplified-setup-container'),
            simplifiedSetupMain: document.querySelector('.ug-ai-nas__simplified-setup-main'),
            simplifiedSetupFeatures: document.querySelectorAll('.ug-ai-nas__simplified-setup-feature'),
            simplifiedSetupImages: document.querySelectorAll('.ug-ai-nas__simplified-setup-image'),
            simplifiedSetupFeaturesMobile: document.querySelectorAll('.ug-ai-nas__simplified-setup-feature-mobile'),
            simplifiedSetupImagesMobile: document.querySelectorAll('.ug-ai-nas__simplified-setup-image-mobile'),
            simplifiedSetupIndicators: document.querySelectorAll('.ug-ai-nas__simplified-setup-indicator'),
            simplifiedSetupContentInner: document.querySelector('.ug-ai-nas__simplified-setup-feature-content-inner'),



            // What is NAS Section
            whatIsNasSection: document.querySelector('.ug-ai-nas__what-is-nas-section'),
            whatIsNasTitle: document.querySelector('.ug-ai-nas__what-is-nas-title'),
            whatIsNasDesc: document.querySelector('.ug-ai-nas__what-is-nas-desc'),
            whatIsNasLink: document.querySelector('.ug-ai-nas__what-is-nas-link'),
            watchIntroBtn: document.querySelector('.ug-ai-nas__watch-intro-btn'),
            videoControlBtn: document.querySelector('.idx-nas-new-videoCtrol-bth'),

            // 新增 - 来自 index1.html 的元素
            producSwiper: document.querySelector('.idx-nas-new-produce-swiper'),
            productCards: document.querySelectorAll('.idx-nas-new-pro-item'),
            preorderButtons: document.querySelectorAll('.idx-preorder-button'),
            specialSwiper: document.querySelector('.idx-nas-new-special-swiper'),
            videoModal: document.getElementById('videoModal'),
            videoModalCloseBtn: document.getElementById('videoModalCloseBtn'),
            youtubePlayer: document.getElementById('youtubePlayer'),
            videoPlayBtns: document.querySelectorAll('.ug-video-play-btn'),

            // Features Showcase Elements
            featuresImageSwiper: document.querySelector('.featuresImageSwiper'),
            featuresTitleSwiper: document.querySelector('.featuresTitleSwiper'),
            featureTitles: document.querySelectorAll('.ug-ai-nas__feature-title'),
            featureImages: document.querySelectorAll('.ug-ai-nas__feature-image'),

                        // Demo Account Elements

            // Demo Account New Elements
            demoAccountNewSection: document.querySelector('.ug-ai-nas__demo-account-new-section'),
            
            // Processing Description Elements
            processingDescriptionSection: document.querySelector('.ug-ai-nas__processing-description-section'),
            processingDescriptionTitle: document.querySelector('.ug-ai-nas__processing-description-title'),
            processingDescriptionText: document.querySelector('.ug-ai-nas__processing-description-text'),
            processingDescriptionStatCards: document.querySelectorAll('.ug-ai-nas__processing-description-stat-card'),
            demoAccountNewCard: document.querySelector('.ug-ai-nas__demo-account-new-card'),
            demoAccountNewTitle: document.querySelector('.ug-ai-nas__demo-account-new-title'),
            demoAccountNewDesc: document.querySelector('.ug-ai-nas__demo-account-new-desc'),
            demoAccountNewButton: document.querySelector('.ug-ai-nas__demo-account-new-button'),
            demoAccountNewMobileCard: document.querySelector('.ug-ai-nas__demo-account-new-mobile-card'),
            demoAccountNewMobileTitle: document.querySelector('.ug-ai-nas__demo-account-new-mobile-title'),
            demoAccountNewMobileDesc: document.querySelector('.ug-ai-nas__demo-account-new-mobile-desc'),
            demoAccountNewMobileButton: document.querySelector('.ug-ai-nas__demo-account-new-mobile-button'),

            // Subscribe Section Elements
            subscribeSection: document.querySelector('.ug-ai-nas__subscribe-section'),
            subscribeForm: document.querySelector('.ug-ai-nas__subscribe-form'),
            subscribeEmailInput: document.querySelector('.ug-ai-nas__email-input'),
            subscribeBtn: document.querySelector('.ug-ai-nas__subscribe-btn'),
            subscribeTermsCheckbox: document.querySelector('.ug-ai-nas__terms-checkbox'),
            subscribeSuccessMsg: document.querySelector('.ug-ai-nas__subscribe-success'),
            subscribeErrorMsg: document.querySelector('.ug-ai-nas__subscribe-error'),

            // Super-Smooth Multitasking Section Elements
            superSmoothMultitaskingSection: document.querySelector('.ug-ai-nas__super-smooth-multitasking-section'),
            multitaskingContainer1: document.querySelector('.multitasking-container1'),
            multitaskingContainer2: document.querySelector('.multitasking-container2'),
            multitaskingBg1: document.querySelector('.multitasking-container1 .ug-ai-nas__super-smooth-multitasking-bg'),
            multitaskingBg2: document.querySelector('.multitasking-container2 .ug-ai-nas__super-smooth-multitasking-bg'),
            multitaskingContent1: document.querySelector('.multitasking-container1 .ug-ai-nas__super-smooth-multitasking-content'),
            multitaskingContent2: document.querySelector('.multitasking-container2 .ug-ai-nas__super-smooth-multitasking-content'),
            multitaskingSubtitle1: document.querySelector('.multitasking-container1 .ug-ai-nas__super-smooth-multitasking-subtitle'),
            multitaskingTitle1: document.querySelector('.multitasking-container1 .ug-ai-nas__super-smooth-multitasking-title'),
            multitaskingSubtitle2: document.querySelector('.multitasking-container2 .ug-ai-nas__super-smooth-multitasking-subtitle'),
            multitaskingTitle2: document.querySelector('.multitasking-container2 .ug-ai-nas__super-smooth-multitasking-title'),
            multitaskingDesc2: document.querySelector('.multitasking-container2 .ug-ai-nas__super-smooth-multitasking-desc'),
                         multitaskingNumberContent: document.querySelector('.ug-ai-nas__super-smooth-multitasking-content-number-content'),
             multitaskingNumberItem: document.querySelector('.ug-ai-nas__super-smooth-multitasking-content-number-content-item'),
             multitaskingProgressBars: document.querySelectorAll('.ug-ai-nas__super-smooth-multitasking-content-number-content-number-line-progress'),

             // AI Intelligent Conversation Section Elements
             intelligentConversationSection: document.querySelector('.ug-ai-nas__intelligent-conversation'),
             intelligentConversationImageSwiper: document.querySelector('.intelligentConversationImageSwiper'),
             intelligentConversationTitleSwiper: document.querySelector('.intelligentConversationTitleSwiper'),
             intelligentConversationTitles: document.querySelectorAll('.ug-ai-nas__intelligent-conversation-title'),
             intelligentConversationDesItems: document.querySelectorAll('.ug-ai-nas__intelligent-conversation-des-item'),
             intelligentConversationVideos: document.querySelectorAll('.ug-ai-nas__intelligent-conversation-video'),
             intelligentConversationVideoOverlays: document.querySelectorAll('.ug-ai-nas__intelligent-conversation-video-overlay'),
             intelligentConversationVideoControls: document.querySelectorAll('.ug-ai-nas__intelligent-conversation-video-control'),
             conversationTitlesPrev: document.querySelector('.ug-ai-nas__conversation-titles-prev'),
             conversationTitlesNext: document.querySelector('.ug-ai-nas__conversation-titles-next'),

             // Deposit Emphasis Section Elements
             depositEmphasisSection: document.querySelector('.ug-ai-nas__deposit-emphasis'),
             depositEmphasisSubtitle: document.querySelector('.ug-ai-nas__deposit-emphasis-subtitle'),
             depositEmphasisTitle: document.querySelector('.ug-ai-nas__deposit-emphasis-title'),
             depositEmphasisButton: document.querySelector('.ug-ai-nas__deposit-emphasis-button'),
             depositEmphasisDesc: document.querySelector('.ug-ai-nas__deposit-emphasis-des'),

            // Mobile Navigation Elements
            mobileNavToggle: document.querySelector('.idx-nas-new-nav-buynow-bth.mobile-nav-toggle'),
            navRightItems: document.querySelector('.idx-nas-new-nav-right-l'),
        };
    },

    /**
     * 设置事件监听器
     */
    setupEventListeners() {
        // Modal事件
        this.setupModalEvents();
        this.setupNasModalEvents();
        
        // Purchase title点击事件
        if (this.elements.purchaseTitleGroup) {
            this.elements.purchaseTitleGroup.style.cursor = 'pointer';
            this.elements.purchaseTitleGroup.addEventListener('click', () => this.openModal());
        }
        
        // What is NAS link点击事件
        if (this.elements.whatIsNasLink) {
            this.elements.whatIsNasLink.style.cursor = 'pointer';
            this.elements.whatIsNasLink.addEventListener('click', (e) => {
                e.preventDefault();
                this.openNasModal();
            });
        }
        
        // 初始化NAS对比表格
        this.initNasComparison();
        
        // 初始化移动端导航
        this.initMobileNavigation();
        
        // 窗口resize事件 - 防抖处理
        window.addEventListener('resize', this.debounce(() => {
            // 刷新所有 ScrollTrigger
            ScrollTrigger.refresh();
            
            // 关闭可能打开的移动端下拉框
            this.closeMobileDropdown();
        }, 250));
        
        // 页面加载完成事件
        window.addEventListener('load', () => {
            gsap.to('body', { 
                opacity: 1, 
                duration: 0.8, 
                ease: this.config.easeDefault 
            });
        });
    },

    /**
     * 设置Modal相关事件
     */
    setupModalEvents() {
        if (!this.elements.modal) return;

        // 关闭按钮
        if (this.elements.modalCloseBtn) {
            this.elements.modalCloseBtn.addEventListener('click', () => this.closeModal());
        }

        // 点击内容区域外关闭弹窗
        this.elements.modal.addEventListener('click', (e) => {
            const modalContent = this.elements.modal.querySelector('.ug-ai-nas__modal-content');
            // 如果点击的不是弹窗内容区域，则关闭弹窗
            if (modalContent && !modalContent.contains(e.target)) {
                this.closeModal();
            }
        });

        // ESC键关闭
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.elements.modal.classList.contains('active')) {
                this.closeModal();
            }
        });
    },

    /**
     * 设置NAS Modal相关事件
     */
    setupNasModalEvents() {
        if (!this.elements.nasModal) return;

        // 关闭按钮
        if (this.elements.nasModalCloseBtn) {
            this.elements.nasModalCloseBtn.addEventListener('click', () => this.closeNasModal());
        }

        // 点击内容区域外关闭弹窗
        this.elements.nasModal.addEventListener('click', (e) => {
            const modalContent = this.elements.nasModal.querySelector('.ug-ai-nas__modal-content');
            // 如果点击的不是弹窗内容区域，则关闭弹窗
            if (modalContent && !modalContent.contains(e.target)) {
                this.closeNasModal();
            }
        });

        // ESC键关闭
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.elements.nasModal.classList.contains('active')) {
                this.closeNasModal();
            }
        });
    },

    /**
     * 初始化所有动画
     */
    initAnimations() {
        // 确保 GSAP 和 ScrollTrigger 已加载
        if (!window.gsap || !window.ScrollTrigger) {
            return;
        }

        // 设置ScrollTrigger全局配置
        ScrollTrigger.config({
            limitCallbacks: true,
            ignoreMobileResize: true
        });

        // 初始化各模块动画
        this.initPurchaseAnimations();
        this.initSuccessAnimations();
        this.initWhatIsNasAnimations();
        this.initDemoAccountNewAnimations();
        this.initDepositEmphasisAnimations();
        this.initProcessingDescriptionAnimations();
        this.initSimplifiedSetupAnimations();
        this.initSmartConnectivityAnimations();
        this.initFastDataTransferAnimations();
        this.initSecurityAnimations();
        this.initServiceAnimations();
        this.initCoolingAnimations();

        // 新增 - 初始化来自 index1.html 的功能
        this.initProductSlider();
        this.initProductInteractions();

        // 特色功能轮播
        this.initSpecialSlider();

        // Features Showcase
        this.initFeaturesShowcase();
    },

    /**
     * Purchase Section动画 - 已移除渐显动效
     */
    initPurchaseAnimations() {
        if (!this.elements.purchaseHeader) return;

        // 确保元素始终可见，不使用动画
        gsap.set([this.elements.purchaseHeader, this.elements.dividerLines, this.elements.purchaseTitleGroup], {
            opacity: 1,
            y: 0,
            scaleX: 1,
            scale: 1
        });

        // 只保留悬停效果，移除ScrollTrigger动画
        this.addPurchaseHoverEffect();
    },

    /**
     * Purchase元素动画 - 已禁用
     */
    animatePurchaseElements() {
        // 动画已移除，保留函数以避免错误
        return;
    },

    /**
     * Purchase悬停效果
     */
    addPurchaseHoverEffect() {
        if (!this.elements.purchaseTitleGroup) return;

        const title = this.elements.purchaseTitleGroup.querySelector('.ug-ai-nas__purchase-title');
        const icon = this.elements.purchaseTitleGroup.querySelector('.ug-ai-nas__purchase-icon');

        if (!title || !icon) return;

        this.elements.purchaseTitleGroup.addEventListener('mouseenter', () => {
            gsap.to(title, { color: '#2563eb', duration: 0.3, ease: this.config.easeDefault });
            gsap.to(icon, { x: 3, duration: 0.3, ease: this.config.easeDefault });
        });

        this.elements.purchaseTitleGroup.addEventListener('mouseleave', () => {
            gsap.to(title, { color: '#337AFF', duration: 0.3, ease: this.config.easeDefault });
            gsap.to(icon, { x: 0, duration: 0.3, ease: this.config.easeDefault });
        });
    },

    /**
     * Success Section动画
     */
    initSuccessAnimations() {
        if (!this.elements.successSection) return;

        // 确保标题直接显示，不需要动画
        if (this.elements.successTitle) {
            gsap.set(this.elements.successTitle, { opacity: 1, y: 0, scale: 1 });
        }

        // 统一ScrollTrigger触发成功页面动画
        ScrollTrigger.create({
            trigger: this.elements.successSection,
            start: "top 80%",
            onEnter: () => {
                this.animateStatCards();
            },
            once: true
        });

        // 背景视差效果
        this.initBackgroundParallax();
    },

    /**
     * 成功页面标题动画 - 已禁用，直接显示
     */
    animateSuccessTitle() {
        if (!this.elements.successTitle) return;

        // 直接设置为可见状态，不使用动画
        gsap.set(this.elements.successTitle, { 
            opacity: 1, 
            y: 0, 
            scale: 1 
        });
    },

    /**
     * 统计卡片动画
     */
    animateStatCards() {
        if (!this.elements.statCards.length) return;

        this.elements.statCards.forEach((card, index) => {
            // 设置初始状态
            gsap.set(card, { opacity: 0, y: 60, scale: 0.8, rotationX: 15 });

            // 动画
            gsap.to(card, {
                opacity: 1,
                y: 0,
                scale: 1,
                rotationX: 0,
                duration: this.config.animationDuration,
                ease: this.config.easeBack,
                delay: index * 0.15
            });

            // 悬停效果
            this.addCardHoverEffect(card);
            
            // 数字计数动画
            this.animateCountUp(card, index);
        });
    },

    /**
     * 卡片悬停效果
     */
    addCardHoverEffect(card) {
        const content = card.querySelector('.ug-ai-nas__stat-content');
        const number = card.querySelector('.ug-ai-nas__stat-number');

        if (!content || !number) return;

        card.addEventListener('mouseenter', () => {
            gsap.to(card, { y: -8, scale: 1.02, duration: 0.3, ease: this.config.easeDefault });
            gsap.to(number, { scale: 1.1, duration: 0.3, ease: this.config.easeDefault });
        });

        card.addEventListener('mouseleave', () => {
            gsap.to(card, { y: 0, scale: 1, duration: 0.3, ease: this.config.easeDefault });
            gsap.to(number, { scale: 1, duration: 0.3, ease: this.config.easeDefault });
        });
    },

    /**
     * 数字计数动画
     */
    animateCountUp(card, index) {
        const numberElement = card.querySelector('.ug-ai-nas__stat-number');
        if (!numberElement) return;

        const originalText = numberElement.textContent;
        const numberMatch = originalText.match(/([\d,]+)/);
        if (!numberMatch) return;

        const targetNumber = parseInt(numberMatch[1].replace(/,/g, ''));
        const prefix = originalText.substring(0, numberMatch.index);
        const suffix = originalText.substring(numberMatch.index + numberMatch[1].length);

        const countObj = { value: 0 };
        gsap.to(countObj, {
            value: targetNumber,
            duration: 2,
            ease: "power2.out",
            delay: index * 0.2 + 0.5,
            onUpdate: () => {
                const formattedNumber = Math.floor(countObj.value).toLocaleString();
                numberElement.textContent = prefix + formattedNumber + suffix;
            }
        });
    },

    /**
     * 背景视差效果
     */
    initBackgroundParallax() {
        if (!this.elements.bgImage) return;

        // 视差滚动
        gsap.to(this.elements.bgImage, {
            y: -50,
            ease: "none",
            scrollTrigger: {
                trigger: this.elements.successSection,
                start: "top bottom",
                end: "bottom top",
                scrub: 1
            }
        });

        // 初始缩放效果
        gsap.fromTo(this.elements.bgImage,
            { scale: 1.1 },
            {
                scale: 1,
                duration: 1.5,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: this.elements.successSection,
                    start: "top 90%",
                    toggleActions: "play none none reverse"
                }
            }
        );
    },

    /**
     * What is NAS Section动画
     */
    initWhatIsNasAnimations() {
        if (!this.elements.whatIsNasSection) return;

        // 初始化元素状态
        const animationElements = [
            this.elements.whatIsNasTitle,
            this.elements.whatIsNasDesc,
            this.elements.whatIsNasLink,
            this.elements.watchIntroBtn
        ].filter(Boolean);

        // 设置初始状态
        gsap.set(animationElements, {
            opacity: 0,
            y: 30
        });

        // 创建动画时间线
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.elements.whatIsNasSection,
                start: 'top 80%',
                end: 'bottom 20%',
                toggleActions: 'play none none reverse',
                once: false
            }
        });

        // 顺序动画
        animationElements.forEach((element, index) => {
            if (element) {
                tl.to(element, {
                    opacity: 1,
                    y: 0,
                    duration: this.config.animationDuration,
                    ease: this.config.easeDefault
                }, index * this.config.staggerDelay);
            }
        });

        // 添加交互效果
        this.addWhatIsNasInteractions();
    },

    /**
     * What is NAS交互效果
     */
    addWhatIsNasInteractions() {
        // 链接悬停效果已移除

        // 播放按钮点击事件（移除悬停动画效果）
        if (this.elements.watchIntroBtn) {
            // 点击事件 - 播放视频
            this.elements.watchIntroBtn.addEventListener('click', () => {
                const videoUrl = this.elements.watchIntroBtn.getAttribute('data-video-url');
                if (videoUrl) {
                    this.openVideoModal(videoUrl);
                }
            });
        }

        // 视频控制按钮点击事件
        if (this.elements.videoControlBtn) {
            this.elements.videoControlBtn.addEventListener('click', () => {
                const videoUrl = this.elements.videoControlBtn.getAttribute('data-url');
                if (videoUrl) {
                    this.openVideoModal(videoUrl);
                }
            });
        }
    },

    /**
     * 打开视频模态框
     */
    openVideoModal(videoUrl) {
        if (!this.elements.videoModal || !this.elements.youtubePlayer) return;
        
        // 直接使用原始链接，不添加任何参数
        this.elements.youtubePlayer.src = videoUrl;
        this.elements.videoModal.classList.add('active');
        document.body.style.overflow = 'hidden';
    },

    /**
     * 关闭视频模态框
     */
    closeVideoModal() {
        if (!this.elements.videoModal || !this.elements.youtubePlayer) return;

        this.elements.videoModal.classList.remove('active');
        this.elements.youtubePlayer.src = '';
        document.body.style.overflow = '';
    },

    /**
     * Demo Account Section动画
     */


    /**
     * Demo Account New Section动画
     */
    initDemoAccountNewAnimations() {
        if (!this.elements.demoAccountNewSection) return;

        // 创建ScrollTrigger动画
        ScrollTrigger.create({
            trigger: this.elements.demoAccountNewSection,
            start: "top 80%",
            onEnter: () => {
                this.animateDemoAccountNewElements();
            },
            once: true
        });

        // 添加按钮交互效果
        this.addDemoAccountNewInteractions();
    },

    /**
     * Demo Account New元素动画
     */
    animateDemoAccountNewElements() {
        // PC版本动画
        if (this.elements.demoAccountNewCard) {
            // 卡片容器动画
            gsap.fromTo(this.elements.demoAccountNewCard,
                { opacity: 0, y: 50, scale: 0.95 },
                { 
                    opacity: 1, 
                    y: 0, 
                    scale: 1, 
                    duration: 0.8, 
                    ease: this.config.easeDefault 
                }
            );

            // 标题动画
            if (this.elements.demoAccountNewTitle) {
                gsap.fromTo(this.elements.demoAccountNewTitle,
                    { opacity: 0, y: 30 },
                    { 
                        opacity: 1, 
                        y: 0, 
                        duration: 0.6, 
                        ease: this.config.easeDefault,
                        delay: 0.2
                    }
                );
            }

            // 描述动画
            if (this.elements.demoAccountNewDesc) {
                gsap.fromTo(this.elements.demoAccountNewDesc,
                    { opacity: 0, y: 30 },
                    { 
                        opacity: 1, 
                        y: 0, 
                        duration: 0.6, 
                        ease: this.config.easeDefault,
                        delay: 0.4
                    }
                );
            }

            // 按钮动画
            if (this.elements.demoAccountNewButton) {
                gsap.fromTo(this.elements.demoAccountNewButton,
                    { opacity: 0, y: 30 },
                    { 
                        opacity: 1, 
                        y: 0, 
                        duration: 0.6, 
                        ease: this.config.easeDefault,
                        delay: 0.6
                    }
                );
            }
        }

        // 移动版本动画
        if (this.elements.demoAccountNewMobileCard) {
            // 卡片容器动画
            gsap.fromTo(this.elements.demoAccountNewMobileCard,
                { opacity: 0, y: 50, scale: 0.95 },
                { 
                    opacity: 1, 
                    y: 0, 
                    scale: 1, 
                    duration: 0.8, 
                    ease: this.config.easeDefault 
                }
            );

            // 标题动画
            if (this.elements.demoAccountNewMobileTitle) {
                gsap.fromTo(this.elements.demoAccountNewMobileTitle,
                    { opacity: 0, y: 30 },
                    { 
                        opacity: 1, 
                        y: 0, 
                        duration: 0.6, 
                        ease: this.config.easeDefault,
                        delay: 0.2
                    }
                );
            }

            // 描述动画
            if (this.elements.demoAccountNewMobileDesc) {
                gsap.fromTo(this.elements.demoAccountNewMobileDesc,
                    { opacity: 0, y: 30 },
                    { 
                        opacity: 1, 
                        y: 0, 
                        duration: 0.6, 
                        ease: this.config.easeDefault,
                        delay: 0.4
                    }
                );
            }

            // 按钮动画
            if (this.elements.demoAccountNewMobileButton) {
                gsap.fromTo(this.elements.demoAccountNewMobileButton,
                    { opacity: 0, y: 30 },
                    { 
                        opacity: 1, 
                        y: 0, 
                        duration: 0.6, 
                        ease: this.config.easeDefault,
                        delay: 0.6
                    }
                );
            }
        }
    },

    /**
     * Demo Account New交互效果
     */
    addDemoAccountNewInteractions() {
        // PC版本按钮点击事件（已移除悬停效果）
        if (this.elements.demoAccountNewButton) {
            // 点击事件
            this.elements.demoAccountNewButton.addEventListener('click', () => {
                // Demo Account New Application Triggered
            });
        }

        // 移动版本按钮点击事件（已移除悬停效果）
        if (this.elements.demoAccountNewMobileButton) {
            // 点击事件
            this.elements.demoAccountNewMobileButton.addEventListener('click', () => {
                // Demo Account New Mobile Application Triggered
            });
        }
    },

    /**
     * Smart Connectivity Section动画
     */
    initSmartConnectivityAnimations() {
        if (!this.elements.smartConnectivitySection) return;

        // 设置初始状态
        this.setSmartConnectivityInitialState();

        // 创建ScrollTrigger
        ScrollTrigger.create({
            trigger: this.elements.smartConnectivitySection,
            start: "top 80%",
            onEnter: () => {
                this.animateSmartConnectivityElements();
            },
            once: true
        });

        // 添加交互效果
        this.addSmartConnectivityInteractions();
    },

    /**
     * 设置Smart Connectivity初始状态
     */
    setSmartConnectivityInitialState() {
        // 背景图片
        if (this.elements.smartConnectivityBg) {
            gsap.set(this.elements.smartConnectivityBg, { 
                opacity: 0, 
                scale: 1.1 
            });
        }

        // 统计卡片
        if (this.elements.smartConnectivityCards.length) {
            this.elements.smartConnectivityCards.forEach(card => {
                gsap.set(card, { 
                    opacity: 0, 
                    y: 60,
                    scale: 0.9
                });
            });
        }
    },

    /**
     * 动画Smart Connectivity元素
     */
    animateSmartConnectivityElements() {
        const tl = gsap.timeline();

        // 1. 背景图片渐显和缩放
        if (this.elements.smartConnectivityBg) {
            tl.to(this.elements.smartConnectivityBg, {
                opacity: 1,
                scale: 1,
                duration: 1.2,
                ease: "power2.out"
            });
        }

        // 2. 统计卡片依次出现，带有数字动画效果
        if (this.elements.smartConnectivityCards.length) {
            this.elements.smartConnectivityCards.forEach((card, index) => {
                tl.to(card, {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    duration: 0.8,
                    ease: "power2.out"
                }, `-=${0.6 - index * 0.15}`);

                // 数字计数动画
                const titleElement = card.querySelector('.ug-ai-nas__smart-connectivity-content-item-card-content-title');
                if (titleElement) {
                    this.animateCountNumber(titleElement, index * 0.2);
                }
            });
        }
    },

    /**
     * 数字计数动画效果
     */
    animateCountNumber(element, delay = 0) {
        const text = element.textContent;
        const numberMatch = text.match(/^([\d.]+)/);
        
        if (numberMatch) {
            const targetNumber = parseFloat(numberMatch[1]);
            const unit = text.replace(numberMatch[1], '');
            
            // 创建一个临时对象来存储当前数值
            const counter = { value: 0 };
            
            gsap.to(counter, {
                value: targetNumber,
                duration: 2,
                delay: delay,
                ease: "power2.out",
                onUpdate: function() {
                    const currentValue = counter.value;
                    let displayValue;
                    
                    // 根据数值大小决定显示格式
                    if (targetNumber >= 100) {
                        displayValue = Math.round(currentValue);
                    } else if (targetNumber >= 10) {
                        displayValue = Math.round(currentValue * 10) / 10;
                    } else {
                        displayValue = Math.round(currentValue * 100) / 100;
                    }
                    
                    element.textContent = displayValue + unit;
                }
            });
        }
    },

    /**
     * 添加Smart Connectivity交互效果
     */
    addSmartConnectivityInteractions() {
        if (this.elements.smartConnectivityCards.length) {
            this.elements.smartConnectivityCards.forEach(card => {
                this.addSmartConnectivityCardHoverEffect(card);
            });
        }
    },

    /**
     * 统计卡片悬停效果
     */
    addSmartConnectivityCardHoverEffect(card) {
        const title = card.querySelector('.ug-ai-nas__smart-connectivity-content-item-card-content-title');
        const subtitle = card.querySelector('.ug-ai-nas__smart-connectivity-content-item-card-content-subtitle');

        card.addEventListener('mouseenter', () => {
            gsap.to(card, {
                y: -8,
                scale: 1.05,
                duration: 0.3,
                ease: "power2.out"
            });

            if (title) {
                gsap.to(title, {
                    color: '#59A3ED',
                    duration: 0.3,
                    ease: "power2.out"
                });
            }

            if (subtitle) {
                gsap.to(subtitle, {
                    color: '#ffffff',
                    duration: 0.3,
                    ease: "power2.out"
                });
            }
        });

        card.addEventListener('mouseleave', () => {
            gsap.to(card, {
                y: 0,
                scale: 1,
                duration: 0.3,
                ease: "power2.out"
            });

            if (title) {
                gsap.to(title, {
                    color: 'rgba(255, 255, 255, 1)',
                    duration: 0.3,
                    ease: "power2.out"
                });
            }

            if (subtitle) {
                gsap.to(subtitle, {
                    color: 'rgba(255, 255, 255, 0.8)',
                    duration: 0.3,
                    ease: "power2.out"
                });
            }
        });

        // 移动端点击效果
        if (window.innerWidth <= 768) {
            card.addEventListener('click', () => {
                gsap.to(card, {
                    scale: 0.98,
                    duration: 0.1,
                    ease: "power2.out",
                    yoyo: true,
                    repeat: 1
                });
            });
        }
    },

    /**
     * Fast Data Transfer Section动画
     */
    initFastDataTransferAnimations() {
        if (!this.elements.fastDataTransferSection || !this.elements.fastDataTransferContainers.length) return;

        // 为每个容器设置初始状态和动画
        this.elements.fastDataTransferContainers.forEach((container, index) => {
            this.setFastDataTransferInitialState(container);
            this.createFastDataTransferScrollTrigger(container, index);
        });
    },

    /**
     * 设置Fast Data Transfer容器的初始状态
     */
    setFastDataTransferInitialState(container) {
        // 获取容器内的所有动画元素
        const subtitle = container.querySelector('.ug-ai-nas__fast-data-transfer-content-subtitle');
        const title = container.querySelector('.ug-ai-nas__fast-data-transfer-content-title');
        const numberItem = container.querySelector('.ug-ai-nas__fast-data-transfer-content-number-content-item');
        const progressBars = container.querySelectorAll('.ug-ai-nas__fast-data-transfer-content-number-content-number-line-progress');
        const desc = container.querySelector('.ug-ai-nas__fast-data-transfer-desc');
        const descList = container.querySelector('.ug-ai-nas__fast-data-transfer-desc-list');

        // 设置初始状态
        if (subtitle) {
            gsap.set(subtitle, { opacity: 0, y: 30 });
        }
        
        if (title) {
            gsap.set(title, { opacity: 0, y: 40 });
        }
        
        if (numberItem) {
            gsap.set(numberItem, { opacity: 0, y: 30 });
        }
        
        if (progressBars.length) {
            progressBars.forEach(bar => {
                gsap.set(bar, { width: 0 });
            });
        }
        
        if (desc) {
            gsap.set(desc, { opacity: 0, y: 20 });
        }
        
        if (descList) {
            const listItems = descList.querySelectorAll('li');
            if (listItems.length) {
                gsap.set(listItems, { opacity: 0, x: -20 });
            }
        }
    },

    /**
     * 创建Fast Data Transfer的ScrollTrigger
     */
    createFastDataTransferScrollTrigger(container, index) {
        // 先清理可能存在的旧触发器
        const existingTriggers = ScrollTrigger.getAll().filter(trigger => 
            trigger.trigger === container
        );
        existingTriggers.forEach(trigger => trigger.kill());

        const trigger = ScrollTrigger.create({
            trigger: container,
            start: "top 80%",
            end: "bottom 20%",
            onEnter: () => {
                this.animateFastDataTransferContainer(container);
            },
            onRefresh: () => {
                // ScrollTrigger刷新时重新检查动画状态
                this._checkContainerAnimationState(container);
            },
            refreshPriority: -1, // 确保在其他触发器之后刷新
            id: `fastDataTransfer-${index}` // 添加ID便于调试
        });

        // 存储触发器引用以便后续管理
        if (!this.scrollTriggers) {
            this.scrollTriggers = {};
        }
        this.scrollTriggers[`fastDataTransfer-${index}`] = trigger;
    },

    /**
     * 检查容器动画状态
     */
    _checkContainerAnimationState(container) {
        const subtitle = container.querySelector('.ug-ai-nas__fast-data-transfer-content-subtitle');
        if (subtitle) {
            const computedStyle = window.getComputedStyle(subtitle);
            const hasAnimation = computedStyle.opacity !== '0';
            
            if (!hasAnimation && this._isInViewport(container)) {
                // 检测到容器需要重新触发动画
                this.animateFastDataTransferContainer(container);
            }
        }
    },

    /**
     * 检查元素是否在视口内
     */
    _isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
    },

    /**
     * 执行Fast Data Transfer容器动画
     */
    animateFastDataTransferContainer(container) {
        const tl = gsap.timeline();
        
        // 获取容器内的所有动画元素
        const subtitle = container.querySelector('.ug-ai-nas__fast-data-transfer-content-subtitle');
        const title = container.querySelector('.ug-ai-nas__fast-data-transfer-content-title');
        const numberItem = container.querySelector('.ug-ai-nas__fast-data-transfer-content-number-content-item');
        const progressBars = container.querySelectorAll('.ug-ai-nas__fast-data-transfer-content-number-content-number-line-progress');
        const desc = container.querySelector('.ug-ai-nas__fast-data-transfer-desc');
        const descList = container.querySelector('.ug-ai-nas__fast-data-transfer-desc-list');

        // 1. 副标题动画
        if (subtitle) {
            tl.to(subtitle, {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: "power2.out"
            });
        }

        // 2. 主标题动画
        if (title) {
            tl.to(title, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: "power2.out"
            }, "-=0.3");
        }

        // 3. 数字项动画
        if (numberItem) {
            tl.to(numberItem, {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: "power2.out"
            }, "-=0.4");
        }

        // 4. 进度条动画
        if (progressBars.length) {
            progressBars.forEach((bar, index) => {
                const targetWidth = this.getFastDataTransferProgressWidth(bar);
                
                tl.to(bar, {
                    width: targetWidth,
                    duration: 1.2,
                    ease: "power2.out"
                }, index === 0 ? "-=0.2" : "-=1.0");
            });
        }

        // 5. 描述文字动画
        if (desc) {
            tl.to(desc, {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: "power2.out"
            }, "-=0.8");
        }

        // 6. 列表项动画
        if (descList) {
            const listItems = descList.querySelectorAll('li');
            if (listItems.length) {
                tl.to(listItems, {
                    opacity: 1,
                    x: 0,
                    duration: 0.5,
                    stagger: 0.1,
                    ease: "power2.out"
                }, "-=0.5");
            }
        }
    },

    /**
     * 获取进度条的目标宽度
     */
    getFastDataTransferProgressWidth(progressBar) {
        const container = progressBar.closest('.ug-ai-nas__fast-data-transfer-content-number-content-number-line-container');
        
        if (container.classList.contains('container1')) {
            return '100%';
        } else if (container.classList.contains('container2')) {
            return '10%';
        } else if (container.classList.contains('container3')) {
            return '5%';
        }
        
        return '50%'; // 默认值
    },

    /**
     * Deposit Emphasis动画初始化
     */
    initDepositEmphasisAnimations() {
        if (!this.elements.depositEmphasisSection) return;

        // 创建ScrollTrigger动画
        ScrollTrigger.create({
            trigger: this.elements.depositEmphasisSection,
            start: "top 80%",
            onEnter: () => {
                this.animateDepositEmphasisElements();
            },
            once: true
        });
    },

    /**
     * Deposit Emphasis元素动画
     */
    animateDepositEmphasisElements() {
        // 副标题动画
        if (this.elements.depositEmphasisSubtitle) {
            gsap.fromTo(this.elements.depositEmphasisSubtitle,
                { opacity: 0, y: 30 },
                { 
                    opacity: 1, 
                    y: 0, 
                    duration: 0.6, 
                    ease: this.config.easeDefault,
                    delay: 0.1
                }
            );
        }

        // 标题动画
        if (this.elements.depositEmphasisTitle) {
            gsap.fromTo(this.elements.depositEmphasisTitle,
                { opacity: 0, y: 30 },
                { 
                    opacity: 1, 
                    y: 0, 
                    duration: 0.6, 
                    ease: this.config.easeDefault,
                    delay: 0.3
                }
            );
        }

        // 按钮动画
        if (this.elements.depositEmphasisButton) {
            gsap.fromTo(this.elements.depositEmphasisButton,
                { opacity: 0, y: 30 },
                { 
                    opacity: 1, 
                    y: 0, 
                    duration: 0.6, 
                    ease: this.config.easeDefault,
                    delay: 0.5
                }
            );
        }

        // 描述文字动画
        if (this.elements.depositEmphasisDesc) {
            gsap.fromTo(this.elements.depositEmphasisDesc,
                { opacity: 0, y: 30 },
                { 
                    opacity: 1, 
                    y: 0, 
                    duration: 0.6, 
                    ease: this.config.easeDefault,
                    delay: 0.7
                }
            );
        }
    },

    /**
     * Security Section动画
     */
    initSecurityAnimations() {
        if (!this.elements.securitySection) return;

        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            // 移动端使用原来的 ScrollTrigger 动画方式
            this.initSecurityMobileAnimations();
        } else {
            // PC端使用新的sticky滚动监听方式
            this.setSecurityInitialState();
            this.createSecurityScrollListener();
            this.addSecurityInteractions();
        }
    },

    /**
     * 设置安全模块初始状态
     */
    setSecurityInitialState() {
        // 初始化状态标志
        this.securityState = {
            elementsAnimated: false,
            lastScrollY: 0
        };

        // 缓存元素引用
        this.securityElements = {
            section: this.elements.securitySection,
            stickyContainer: this.elements.securityStickyContainer,
            bg: this.elements.securityBg,
            bgImg: this.elements.securityBgImg,
            bgIcon: this.elements.securityBgIcon,
            content: this.elements.securityContent,
            title: this.elements.securityTitle,
            features: this.elements.securityFeatures,
            cards: this.elements.securityCards
        };

        // 设置初始状态
        if (this.securityElements.bgImg) {
            gsap.set(this.securityElements.bgImg, { scale: 1.3, y: 30 });
        }
        
        if (this.securityElements.bgIcon) {
            gsap.set(this.securityElements.bgIcon, { opacity: 0, y: 30 });
        }
        
        if (this.securityElements.title) {
            gsap.set(this.securityElements.title, { opacity: 0, y: 30 });
        }
        
        if (this.securityElements.cards && this.securityElements.cards.length > 0) {
            gsap.set(this.securityElements.cards, { opacity: 0, y: 40 });
        }

        // Security initial state set
    },

    /**
     * 移动端Security动画 - 基于滚动距离的渐显
     */
    initSecurityMobileAnimations() {
        // 背景图片缩放动画 - 更早开始
        if (this.elements.securityBgImg) {
            gsap.fromTo(this.elements.securityBgImg,
                {
                    scale: 1.5,
                    y: 50
                },
                {
                    scale: 1,
                    y: 0,
                    duration: 1.2,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: this.elements.securityBg,
                        start: "top 90%", // 从 80% 提前到 90%
                        end: "bottom 70%", // 从 60% 调整到 70%
                        scrub: 1
                    }
                }
            );
        }

        // 安全图标动画 - 提前显示
        if (this.elements.securityBgIcon) {
            gsap.fromTo(this.elements.securityBgIcon, 
                { opacity: 0, y: 40 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: this.elements.securityBg,
                        start: "bottom 80%", // 从 65% 提前到 80%
                        end: "bottom 70%", // 从 55% 调整到 70%
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }

        // 标题动画 - 提前显示
        if (this.elements.securityTitle) {
            gsap.fromTo(this.elements.securityTitle, 
                { opacity: 0, y: 40 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: this.elements.securityBg,
                        start: "bottom 70%", // 从 50% 提前到 70%
                        end: "bottom 60%", // 从 40% 调整到 60%
                        toggleActions: "play none none reverse"
                    }
                }
            );
        }

        // 卡片动画 - 提前显示
        if (this.elements.securityCards && this.elements.securityCards.length > 0) {
            gsap.fromTo(this.elements.securityCards, 
                { opacity: 0, y: 40 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    stagger: 0.15,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: this.elements.securityBg,
                        start: "bottom 60%", // 从 40% 提前到 60%
                        end: "bottom 40%", // 从 20% 调整到 40%
                        toggleActions: "play none none reverse"
                    }
                }
            );

            // 添加悬停效果
            this.elements.securityCards.forEach((card) => {
                this.addSecurityCardHoverEffect(card);
            });
        }
    },

    /**
     * 创建安全模块滚动监听器
     */
    createSecurityScrollListener() {
        const section = this.securityElements.section;
        
        // 防抖函数
        let ticking = false;
        
        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    this.updateSecurityOnScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };

        // 监听滚动事件
        window.addEventListener('scroll', handleScroll, { passive: true });
        
        // 初始检查
        setTimeout(() => {
            this.updateSecurityOnScroll();
        }, 100);

        // Security scroll listener created
    },

    /**
     * 滚动时更新安全模块动画
     */
    updateSecurityOnScroll() {
        const section = this.securityElements.section;
        if (!section) return;

        // 计算section相对于视口的位置
        const rect = section.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const sectionHeight = section.offsetHeight;
        
        // 计算滚动进度 (0-1)
        let progress = 0;
        
        if (rect.top <= 0) {
            const scrolledInSection = Math.abs(rect.top);
            const maxScroll = sectionHeight - windowHeight;
            progress = Math.min(scrolledInSection / maxScroll, 1);
        }
        
        // 限制进度范围
        progress = Math.max(0, Math.min(1, progress));
        
        // console.log(`Security progress: ${(progress * 100).toFixed(1)}%`);
        
        // 根据进度控制动画
        this.controlSecurityByProgress(progress);
    },

    /**
     * 根据滚动进度控制安全模块动画
     */
    controlSecurityByProgress(progress) {
        // 定义动画触发点
        const BG_ANIMATION_START = 0.1;    // 背景动画开始
        const CONTENT_ANIMATION_START = 0.6; // 内容动画开始
        
        // 背景图片缩放动画
        if (this.securityElements.bgImg) {
            const bgProgress = Math.max(0, Math.min(1, (progress - BG_ANIMATION_START) / 0.5));
            const scale = 1.3 - (bgProgress * 0.3); // 从1.3到1
            const y = 30 - (bgProgress * 30); // 从30到0
            
            gsap.set(this.securityElements.bgImg, { 
                scale: scale,
                y: y 
            });
        }
        
        // 触发内容动画
        if (progress >= CONTENT_ANIMATION_START && !this.securityState.elementsAnimated) {
            this.securityState.elementsAnimated = true;
            this.animateSecurityElements();
        }
        
        // 重置动画状态（向上滚动时）
        if (progress < CONTENT_ANIMATION_START && this.securityState.elementsAnimated) {
            this.resetSecurityAnimationState();
        }
    },

    /**
     * 执行安全模块元素动画
     */
    animateSecurityElements() {
        // Starting Security animations
        
        // 安全图标动画
        if (this.securityElements.bgIcon) {
            gsap.to(this.securityElements.bgIcon, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: "power2.out"
            });
        }
        
        // 标题动画
        if (this.securityElements.title) {
            gsap.to(this.securityElements.title, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                delay: 0.2,
                ease: "power2.out"
            });
        }
        
        // 卡片动画
        if (this.securityElements.cards && this.securityElements.cards.length > 0) {
            gsap.to(this.securityElements.cards, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                delay: 0.4,
                stagger: 0.15,
                ease: "power2.out"
            });
        }
    },

    /**
     * 重置安全模块动画状态
     */
    resetSecurityAnimationState() {
        // Resetting security animation state
        
        this.securityState.elementsAnimated = false;
        
        // 重置到初始状态
        if (this.securityElements.bgIcon) {
            gsap.set(this.securityElements.bgIcon, { opacity: 0, y: 30 });
        }
        
        if (this.securityElements.title) {
            gsap.set(this.securityElements.title, { opacity: 0, y: 30 });
        }
        
        if (this.securityElements.cards && this.securityElements.cards.length > 0) {
            gsap.set(this.securityElements.cards, { opacity: 0, y: 40 });
        }
    },

    /**
     * 添加安全模块交互效果
     */
    addSecurityInteractions() {
        // 为卡片添加悬停效果
        if (this.securityElements.cards && this.securityElements.cards.length > 0) {
            this.securityElements.cards.forEach((card) => {
                this.addSecurityCardHoverEffect(card);
            });
        }
    },


    /**
     * Security卡片悬停效果
     */
    addSecurityCardHoverEffect(card) {
        card.addEventListener('mouseenter', () => {
            gsap.to(card, { y: -8, duration: 0.3, ease: 'power2.out' });
        });

        card.addEventListener('mouseleave', () => {
            gsap.to(card, { y: 0, duration: 0.3, ease: 'power2.out' });
        });
    },

    /**
     * Service Section动画
     */
    initServiceAnimations() {
        if (!this.elements.serviceSection) return;

        ScrollTrigger.create({
            trigger: this.elements.serviceSection,
            start: "top 80%",
            onEnter: () => {
                this.animateServiceElements();
            },
            once: true
        });
    },

    /**
     * Service元素动画
     */
    animateServiceElements() {
        // 标题动画
        this.elements.serviceTitles.forEach((title, index) => {
            gsap.fromTo(title,
                { opacity: 0, y: 50, scale: 0.95 },
                { 
                    opacity: 1, 
                    y: 0, 
                    scale: 1, 
                    duration: 1, 
                    ease: "power3.out",
                    delay: index * 0.2
                }
            );
        });

        // 服务卡片动画
        this.elements.serviceCards.forEach((card, index) => {
            gsap.fromTo(card,
                { opacity: 0, y: 60, scale: 0.9, rotationY: 15 },
                {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    rotationY: 0,
                    duration: this.config.animationDuration,
                    ease: this.config.easeBack,
                    delay: 0.5 + (index % 3) * this.config.staggerDelay
                }
            );

            this.addServiceCardHoverEffect(card);
        });

        // 质量统计动画
        this.elements.qualityStats.forEach((stat, index) => {
            gsap.fromTo(stat,
                { opacity: 0, scale: 0.8, y: 40 },
                {
                    opacity: 1,
                    scale: 1,
                    y: 0,
                    duration: this.config.animationDuration,
                    ease: "power3.out",
                    delay: 1 + index * 0.15
                }
            );

            this.animateQualityNumber(stat);
            this.addQualityStatHoverEffect(stat);
        });
    },

    /**
     * Service卡片悬停效果
     */
    addServiceCardHoverEffect(card) {
        const icon = card.querySelector('.ug-ai-nas__service-icon');
        const title = card.querySelector('.ug-ai-nas__service-card-title');

        if (!icon || !title) return;

        card.addEventListener('mouseenter', () => {
            gsap.to(card, { y: -12, scale: 1.02, duration: 0.3, ease: this.config.easeDefault });
            gsap.to(icon, { scale: 1.1, rotation: 0, duration: 0.3, ease: this.config.easeDefault });
        });

        card.addEventListener('mouseleave', () => {
            gsap.to(card, { y: 0, scale: 1, duration: 0.3, ease: this.config.easeDefault });
            gsap.to(icon, { scale: 1, rotation: 0, duration: 0.3, ease: this.config.easeDefault });
        });
    },

    /**
     * 质量统计悬停效果
     */
    addQualityStatHoverEffect(stat) {
        const number = stat.querySelector('.ug-ai-nas__quality-stat-number');

        stat.addEventListener('mouseenter', () => {
            gsap.to(stat, { y: -6, scale: 1.02, duration: 0.3, ease: this.config.easeDefault });
            if (number) gsap.to(number, { scale: 1.05, duration: 0.3, ease: this.config.easeDefault });
        });

        stat.addEventListener('mouseleave', () => {
            gsap.to(stat, { y: 0, scale: 1, duration: 0.3, ease: this.config.easeDefault });
            if (number) gsap.to(number, { scale: 1, duration: 0.3, ease: this.config.easeDefault });
        });
    },

    /**
     * 质量数字动画
     */
    animateQualityNumber(stat) {
        const valueElement = stat.querySelector('.ug-ai-nas__stat-value');
        if (!valueElement) return;

        const originalText = valueElement.textContent;
        const targetNumber = parseInt(originalText.replace(/,/g, ''));

        if (isNaN(targetNumber)) return;

        const countObj = { value: 0 };
        gsap.to(countObj, {
            value: targetNumber,
            duration: 2,
            ease: "power2.out",
            delay: 0.5,
            onUpdate: () => {
                const formattedNumber = Math.floor(countObj.value).toLocaleString();
                valueElement.textContent = formattedNumber;
            }
        });
    },

    /**
     * Cooling Section动画 - sticky + 滚动监听效果
     */
    initCoolingAnimations() {
        if (!this.elements.coolingSection || !this.elements.coolingContainers.length) return;

        // 检测设备类型
        const isMobile = window.innerWidth <= 768;
        
        if (isMobile) {
            // 移动端使用原始 ScrollTrigger 动画
            this.initCoolingMobileAnimations();
        } else {
            // PC端使用新的 sticky + 滚动监听
            this.setCoolingInitialState();
            this.createCoolingScrollListener();
            this.addCoolingInteractions();
        }
        
        // 初始化冷却显示切换功能
        this.initCoolingChangeInteraction();
    },

    /**
     * 设置 Cooling 初始状态
     */
    setCoolingInitialState() {
        this.elements.coolingContainers.forEach((container, index) => {
            if (index === 0) {
                // 第一个容器默认可见
                gsap.set(container, { 
                    y: 0,
                    opacity: 1,
                    scale: 1
                });
                // 标记第一个容器为激活状态
                container.dataset.coolingActive = 'true';
            } else {
                // 其他容器初始隐藏
                gsap.set(container, { 
                    y: "100vh",
                    opacity: 0,
                    scale: 0.8
                });
                // 标记其他容器为非激活状态
                container.dataset.coolingActive = 'false';
            }
            
            // 设置文字元素初始状态
            const subtitle = container.querySelector('.ug-ai-nas__cooling-subtitle');
            const title = container.querySelector('.ug-ai-nas__cooling-title');
            const desc = container.querySelector('.ug-ai-nas__cooling-desc');
            const coolingChange = container.querySelector('.ug-ai-nas__cooling-change');
            
            if (index === 0) {
                // 第一个容器的文字默认可见
                [subtitle, title, desc, coolingChange].forEach(element => {
                    if (element) {
                        gsap.set(element, { opacity: 1, y: 0 });
                    }
                });
            } else {
                // 其他容器的文字初始隐藏
                [subtitle, title, desc].forEach(element => {
                    if (element) {
                        gsap.set(element, { opacity: 0, y: 50 });
                    }
                });
            }
        });
    },

    /**
     * 移动端 Cooling 动画 - 保持原有的 ScrollTrigger 方式
     */
    initCoolingMobileAnimations() {
        this.elements.coolingContainers.forEach((container, index) => {
            // 重置容器样式为移动端适配
            gsap.set(container, { clearProps: "all" });
            
            // 为文字元素添加动画
            const subtitle = container.querySelector('.ug-ai-nas__cooling-subtitle');
            const title = container.querySelector('.ug-ai-nas__cooling-title');
            const desc = container.querySelector('.ug-ai-nas__cooling-desc');
            const coolingChange = container.querySelector('.ug-ai-nas__cooling-change');
            
            const textElements = [subtitle, title, desc, coolingChange].filter(Boolean);
            
            textElements.forEach((element, textIndex) => {
                gsap.fromTo(element,
                    { opacity: 0, y: 30 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.8,
                        ease: "power2.out",
                        scrollTrigger: {
                            trigger: element,
                            start: "top 80%", // 更早触发
                            end: "bottom 20%",
                            toggleActions: "play none none reverse"
                        }
                    }
                );
            });
        });
    },

    /**
     * 创建 Cooling 滚动监听器
     */
    createCoolingScrollListener() {
        let ticking = false;
        
        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    this.updateCoolingOnScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
    },

    /**
     * 根据滚动更新 Cooling 状态
     */
    updateCoolingOnScroll() {
        const sectionRect = this.elements.coolingSection.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // 计算滚动进度
        const scrollProgress = Math.max(0, Math.min(1, 
            -sectionRect.top / (sectionRect.height - windowHeight)
        ));
        
        this.controlCoolingByProgress(scrollProgress);
    },

    /**
     * 根据进度控制 Cooling 容器
     */
    controlCoolingByProgress(progress) {
        const totalContainers = this.elements.coolingContainers.length;
        const progressPerContainer = 1 / totalContainers;
        
        this.elements.coolingContainers.forEach((container, index) => {
            const containerStartProgress = index * progressPerContainer;
            const containerEndProgress = (index + 1) * progressPerContainer;
            
            // 如果是最后一个容器且进度超过其结束点，保持激活状态
            if (index === totalContainers - 1 && progress >= containerStartProgress) {
                this.animateCoolingContainer(container, index, true);
            } else if (progress >= containerStartProgress && progress < containerEndProgress) {
                // 当前激活的容器
                this.animateCoolingContainer(container, index, true);
            } else if (progress < containerStartProgress) {
                // 尚未到达的容器
                this.resetCoolingContainer(container, index, false);
            } else if (index < totalContainers - 1) {
                // 已经过去的容器（但不是最后一个）
                this.resetCoolingContainer(container, index, true);
            }
        });
    },

    /**
     * 动画显示 Cooling 容器
     */
    animateCoolingContainer(container, index, isActive) {
        if (!isActive) return;
        
        // 检查容器是否已经处于激活状态，避免重复动画
        if (container.dataset.coolingActive === 'true') return;
        
        // 标记为激活状态
        container.dataset.coolingActive = 'true';
        
        // 容器动画
        gsap.to(container, {
            y: 0,
            opacity: 1,
            scale: 1,
            duration: 0.8,
            ease: "power2.out"
        });
        
        // 文字动画
        const subtitle = container.querySelector('.ug-ai-nas__cooling-subtitle');
        const title = container.querySelector('.ug-ai-nas__cooling-title');
        const desc = container.querySelector('.ug-ai-nas__cooling-desc');
        const coolingChange = container.querySelector('.ug-ai-nas__cooling-change');
        
        const textElements = [subtitle, title, desc, coolingChange].filter(Boolean);
        
        textElements.forEach((element, textIndex) => {
            gsap.to(element, {
                opacity: 1,
                y: 0,
                duration: 0.6,
                delay: textIndex * 0.1,
                ease: "power2.out"
            });
        });
    },

    /**
     * 重置 Cooling 容器状态
     */
    resetCoolingContainer(container, index, isPassed) {
        // 清除激活状态标记
        container.dataset.coolingActive = 'false';
        
        if (isPassed) {
            // 已经过去的容器 - 隐藏在上方
            gsap.to(container, {
                y: "-100vh",
                opacity: 0,
                scale: 0.8,
                duration: 0.8,
                ease: "power2.out"
            });
        } else {
            // 尚未到达的容器 - 隐藏在下方
            gsap.to(container, {
                y: "100vh",
                opacity: 0,
                scale: 0.8,
                duration: 0.8,
                ease: "power2.out"
            });
        }
        
        // 隐藏文字
        const subtitle = container.querySelector('.ug-ai-nas__cooling-subtitle');
        const title = container.querySelector('.ug-ai-nas__cooling-title');
        const desc = container.querySelector('.ug-ai-nas__cooling-desc');
        const coolingChange = container.querySelector('.ug-ai-nas__cooling-change');
        
        const textElements = [subtitle, title, desc, coolingChange].filter(Boolean);
        
        textElements.forEach((element) => {
            if (element && index !== 0) { // 保持第一个容器的文字
                gsap.to(element, {
                    opacity: 0,
                    y: 50,
                    duration: 0.4,
                    ease: "power2.out"
                });
            }
        });
    },

    /**
     * 添加 Cooling 交互效果
     */
    addCoolingInteractions() {
        // 此方法保留用于添加悬停效果等交互
        // 目前无需特殊交互，保留方法避免调用错误
    },





    /**
     * 移动端 step-1 文案提前出现动画
     */
    addStep1MobileTextAnimations(textElements) {
        // 初始隐藏所有文字元素
        textElements.forEach((element) => {
            gsap.set(element, { opacity: 0, y: 30 });
        });

        // 为每个文字元素添加独立的ScrollTrigger，当滚动到视觉中心就出现
        textElements.forEach((element, index) => {
            gsap.fromTo(element,
                { opacity: 0, y: 30 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: element,
                        start: "top 70%", // 当元素顶部距离视口底部70%时触发（视觉中心）
                        end: "bottom 30%",
                        toggleActions: "play none none reverse"
                    }
                }
            );
        });
    },

    /**
     * Cooling悬停效果（已移除鼠标监听器）
     */
    addCoolingHoverEffect() {
        // 鼠标悬停效果已移除，保留方法以避免调用错误
        // 如需悬停效果，请使用CSS :hover 伪类实现
    },

    /**
     * 初始化Cooling切换交互功能
     */
    initCoolingChangeInteraction() {
        if (!this.elements.coolingChangeItems.length || !this.elements.coolingBgImages.length) return;

        // 设置初始状态 - 第一张图片默认显示
        this.elements.coolingBgImages.forEach((img, index) => {
            if (index === 0) {
                img.classList.add('active');
            } else {
                img.classList.remove('active');
            }
        });

        // 为每个切换项添加点击事件
        this.elements.coolingChangeItems.forEach((item, index) => {
            item.addEventListener('click', () => {
                // 移除所有项的active类
                this.elements.coolingChangeItems.forEach(changeItem => {
                    changeItem.classList.remove('active');
                });
                
                // 为点击的项添加active类
                item.classList.add('active');

                // 切换对应的背景图片
                this.elements.coolingBgImages.forEach((img, imgIndex) => {
                    if (imgIndex === index) {
                        img.classList.add('active');
                    } else {
                        img.classList.remove('active');
                    }
                });

                // 切换到显示模式
            });

            // 添加悬停样式（通过CSS处理）
            item.style.cursor = 'pointer';
        });
    },

    /**
     * 初始化产品轮播图 - 来自 index1.html
     */
    initProductSlider() {
        if (!this.elements.producSwiper) return;

        // 初始化 Swiper
        const produceSwiper = new Swiper('.idx-nas-new-produce-swiper', {
            slidesPerView: 'auto',
            spaceBetween: 15,
            speed: 800,
            grabCursor: true,
            breakpoints: {
                768: {
            spaceBetween: 20,
                }
            },
            navigation: {
                nextEl: '.idx-nas-new-produce .swiper-button-next',
                prevEl: '.idx-nas-new-produce .swiper-button-prev',
            },
            effect: 'slide',
            cssMode: false,
            mousewheel: {
                forceToAxis: true
            }
        });
    },

    /**
     * 初始化产品交互 - 来自 index1.html
     */
    initProductInteractions() {
        // 产品卡片点击事件
        this.elements.productCards.forEach((card) => {
            card.addEventListener('click', (event) => {
                // 防止点击按钮时触发卡片点击事件
                if (event.target.closest('.idx-preorder-button')) {
                    return;
                }

                // 移除所有卡片的active类
                this.elements.productCards.forEach((c) => c.classList.remove('active'));
                // 为点击的卡片添加active类
                card.classList.add('active');
            });
        });

        // 预订按钮点击事件
        this.elements.preorderButtons.forEach((button) => {
            button.addEventListener('click', async (event) => {
                event.preventDefault();

                const variantId = button.getAttribute('data-variant-id');
                const productHandle = button.getAttribute('data-product-handle');
                const productId = button.getAttribute('data-product-id');

                // Checkout attempt

                // 使用可用的ID
                const checkoutVariantId = variantId || '43893908209871'; // 备用ID

                if (checkoutVariantId) {
                    try {
                        // 显示加载状态
                        const buttonText = button.querySelector('span');
                        const originalText = buttonText.textContent;
                        buttonText.textContent = 'Processing...';

                        // 使用标准购物车API
                        const response = await fetch('/cart/clear.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        });

                        if (!response.ok) throw new Error('Failed to clear cart');

                        const addResponse = await fetch('/cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                items: [
                                    {
                                        id: checkoutVariantId,
                                        quantity: 1,
                                    },
                                ],
                            }),
                        });

                        if (!addResponse.ok) throw new Error('Failed to add to cart');

                        // 重定向到结账页面
                        window.location.href = '/checkout';
                    } catch (error) {
                        // 静默处理错误
                        alert('There was an error processing your request. Please try again.');

                        // 恢复按钮文本
                        const buttonText = button.querySelector('span');
                        if (buttonText && originalText) {
                            buttonText.textContent = originalText;
                        }
                    }
                } else if (productHandle) {
                    // 如果有产品handle，跳转到产品页面
                    window.location.href = '/products/' + productHandle;
                } else {
                    // 如果都没有，显示错误信息
                    alert("Sorry, we couldn't find the product information. Please try another product.");
                }
            });
        });
    },

    /**
     * 打开弹窗
     */
    openModal() {
        if (!this.elements.modal) return;
        document.body.style.overflow = 'hidden';
        this.elements.modal.classList.add('active');
    },

    /**
     * 关闭弹窗
     */
    closeModal() {
        if (!this.elements.modal) return;
        document.body.style.overflow = '';
        this.elements.modal.classList.remove('active');
    },

    /**
     * 打开NAS对比弹窗
     */
    openNasModal() {
        if (!this.elements.nasModal) return;
        document.body.style.overflow = 'hidden';
        this.elements.nasModal.classList.add('active');
    },

    /**
     * 关闭NAS对比弹窗
     */
    closeNasModal() {
        if (!this.elements.nasModal) return;
        document.body.style.overflow = '';
        this.elements.nasModal.classList.remove('active');
    },

    /**
     * 初始化NAS对比表格
     */
    initNasComparison() {
        if (!this.elements.nasComparisonContainer) return;
        
        // 对比数据配置
        this.nasComparisonData = {
            products: [
                {
                    name: 'Ugreen AI NAS',
                    image: 'https://cdn.shopify.com/s/files/1/0630/9416/1602/files/Frame_1618874079.png?v=1750937910',
                    alt: 'Ugreen AI NAS'
                },
                {
                    name: 'External Hard Drives',
                    image: 'https://cdn.shopify.com/s/files/1/0630/9416/1602/files/external-hard-drive-icon.png?v=1750342833',
                    alt: 'External Hard Drive'
                },
                {
                    name: 'Cloud Storage',
                    image: 'https://cdn.shopify.com/s/files/1/0630/9416/1602/files/cloud-storage-icon.png?v=1750342841',
                    alt: 'Cloud Storage'
                }
            ],
            features: [
                {
                    name: 'Long-Term Cost',
                    values: [
                        { type: 'check', text: 'One-time purchase no ongoing fees', isGood: true },
                        { type: 'check', text: 'Low cost but limited capacity', isGood: false },
                        { type: 'cross', text: 'High fees add up over time', isGood: false }
                    ]
                },
                {
                    name: 'Storage Capacity',
                    values: [
                        { type: 'check', text: 'Flexible and expandable', isGood: true },
                        { type: 'cross', text: 'Fixed (typically no more than ~20TB)', isGood: false },
                        { type: 'cross', text: 'Limited and inflexible', isGood: false }
                    ]
                },
                {
                    name: 'Data Security',
                    values: [
                        { type: 'check', text: 'Strong encryption and secure local storage', isGood: true },
                        { type: 'cross', text: 'No encryption by default, easily stolen', isGood: false },
                        { type: 'cross', text: 'Risk of hacks and data leaks', isGood: false }
                    ]
                },
                {
                    name: 'Transfer Speed',
                    values: [
                        { type: 'check', text: 'Up to 2500MB/s via LAN', isGood: true },
                        { type: 'check', text: 'Over 1000MB/s with SSD', isGood: false },
                        { type: 'cross', text: 'Limited by internet speed, unstable', isGood: false }
                    ]
                },
                {
                    name: 'Accessibility',
                    values: [
                        { type: 'check', text: 'Local (LAN) and remote access', isGood: true },
                        { type: 'cross', text: 'Requires physical connection', isGood: false },
                        { type: 'check', text: 'Accessible via internet', isGood: false }
                    ]
                },
                {
                    name: 'Multi-User Collaboration',
                    values: [
                        { type: 'check', text: 'Multi-user with real-time sync', isGood: true },
                        { type: 'cross', text: 'Single-user only', isGood: false },
                        { type: 'cross', text: 'Sharing needs links, collaboration laggy', isGood: false }
                    ]
                },
                {
                    name: 'Privacy Control',
                    values: [
                        { type: 'check', text: 'Full local control, easily manage permissions', isGood: true },
                        { type: 'check', text: 'Typically no permissions control', isGood: false },
                        { type: 'cross', text: 'Hacks and unauthorized access possible', isGood: false }
                    ]
                },
                {
                    name: 'Scalability',
                    values: [
                        { type: 'check', text: 'Easy to upgrade, Docker support', isGood: true },
                        { type: 'cross', text: 'Must buy new one when full', isGood: false },
                        { type: 'cross', text: 'Can only upgrade to fixed packages', isGood: false }
                    ]
                },
                {
                    name: 'Reliability',
                    values: [
                        { type: 'check', text: 'RAID redundancy, built to last', isGood: true },
                        { type: 'cross', text: 'Limited lifespan, total data loss on failure', isGood: false },
                        { type: 'cross', text: 'Third party could cease service', isGood: false }
                    ]
                }
            ]
        };

        // 生成对比表格HTML
        this.renderNasComparison();
    },

    /**
     * 生成对比表格HTML
     */
    renderNasComparison() {
        const data = this.nasComparisonData;
        
        const html = `
            <div class="ug-ai-nas__comparison-container-auto">
                <div class="ug-ai-nas__comparison-container">
                    <!-- Table Header -->
                    <div class="ug-ai-nas__comparison-header">
                        <div class="ug-ai-nas__comparison-header-label">Feature</div>
                        <div class="ug-ai-nas__comparison-products">
                            ${data.products.map(product => `
                                <div class="ug-ai-nas__comparison-product">
                                    <div class="ug-ai-nas__comparison-product-content">
                                        <div class="ug-ai-nas__comparison-product-image">
                                            <img src="${product.image}" alt="${product.alt}" />
                                        </div>
                                        <div class="ug-ai-nas__comparison-product-name">
                                            ${product.name}
                                        </div>
                                    </div>
                                </div>
                            `).join('')}
                        </div>
                    </div>

                    <!-- Comparison Rows -->
                    <div class="ug-ai-nas__comparison-rows">
                        ${data.features.map(feature => `
                            <div class="ug-ai-nas__comparison-row">
                                <div class="ug-ai-nas__comparison-feature-label">${feature.name}</div>
                                <div class="ug-ai-nas__comparison-values">
                                    ${feature.values.map(value => `
                                        <div class="ug-ai-nas__comparison-value">
                                            <div class="ug-ai-nas__comparison-icon ug-ai-nas__comparison-icon--${value.type}">
                                                ${this.getIconSvg(value.type)}
                                            </div>
                                            <span class="ug-ai-nas__comparison-text ${value.isGood ? 'ug-ai-nas__comparison-text--good' : ''}">${value.text}</span>
                                        </div>
                                    `).join('')}
                                </div>
                            </div>
                        `).join('')}
                    </div>
                </div>
            </div>
        `;

        this.elements.nasComparisonContainer.innerHTML = html;
    },

    /**
     * 获取图标SVG
     */
    getIconSvg(type) {
        if (type === 'check') {
            return `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12.0005 1.5C6.20205 1.5 1.50049 6.20156 1.50049 12C1.50049 17.7984 6.20205 22.5 12.0005 22.5C17.7989 22.5 22.5005 17.7984 22.5005 12C22.5005 6.20156 17.7989 1.5 12.0005 1.5ZM16.5356 8.57109L11.5997 15.4148C11.5307 15.5111 11.4398 15.5896 11.3344 15.6437C11.229 15.6978 11.1123 15.7261 10.9938 15.7261C10.8754 15.7261 10.7586 15.6978 10.6533 15.6437C10.5479 15.5896 10.457 15.5111 10.388 15.4148L7.46533 11.3648C7.37627 11.2406 7.46533 11.0672 7.61768 11.0672H8.71689C8.95596 11.0672 9.1833 11.182 9.32393 11.3789L10.9927 13.6945L14.6771 8.58516C14.8177 8.39062 15.0427 8.27344 15.2841 8.27344H16.3833C16.5356 8.27344 16.6247 8.44688 16.5356 8.57109Z" fill="#337AFF"/>
                </svg>
            `;
        } else if (type === 'cross') {
            return `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.50098C17.7984 1.50098 22.5 6.20254 22.5 12.001C22.5 17.7994 17.7984 22.501 12 22.501C6.20156 22.501 1.5 17.7994 1.5 12.001C1.5 6.20254 6.20156 1.50098 12 1.50098ZM14.9995 7.94207C14.9989 7.94223 14.9977 7.94263 14.9967 7.94359L12 10.9403L9.00328 7.94359C9.0023 7.94263 9.00188 7.94238 9.00131 7.94221C9.00078 7.94205 9.00185 7.94205 9.00131 7.94221C9.0008 7.94238 8.99871 7.94263 8.99775 7.94359L7.94259 8.99873C7.94166 8.99966 7.94142 9.00013 7.94123 9.00067C7.94107 9.00014 7.94107 9.00121 7.94123 9.00067L7.94147 9.00283C7.94178 9.00335 7.94217 9.00382 7.94262 9.00423L10.9393 12.001L7.94262 14.9977C7.94166 14.9987 7.9414 14.9991 7.94123 14.9997C7.94107 14.9992 7.94107 15.0002 7.94123 14.9997C7.9414 15.0002 7.94166 15.0023 7.94262 15.0033L8.99775 16.0584C8.99869 16.0593 8.99916 16.0596 8.9997 16.0598C8.99916 16.0599 9.00023 16.0599 8.9997 16.0598C9.00021 16.0596 9.0023 16.0593 9.00326 16.0584L12 13.0616L14.9968 16.0584C14.9977 16.0593 14.9982 16.0596 14.9987 16.0597C14.9982 16.0599 14.9992 16.0599 14.9987 16.0597C14.9992 16.0596 15.0013 16.0593 15.0023 16.0584L16.0574 15.0032C16.0584 15.0023 16.0586 15.0018 16.0588 15.0013C16.059 15.0007 16.059 15.0018 16.0588 15.0013L16.0586 14.9991C16.0582 14.9986 16.0579 14.9981 16.0574 14.9977L13.0606 12.001L16.0574 9.00426C16.0583 9.00327 16.0586 9.00285 16.0588 9.00229C16.0589 9.00176 16.0589 9.00282 16.0588 9.00229C16.0586 9.00177 16.0583 8.99969 16.0574 8.99873L15.0023 7.94357C15.0017 7.94296 15.0002 7.94235 14.9995 7.94207C15 7.9419 14.999 7.9419 14.9995 7.94207Z" fill="black" fill-opacity="0.3"/>
                </svg>
            `;
        }
        return '';
    },

    /**
     * 更新对比数据（用于后续扩展）
     */
    updateNasComparisonData(newData) {
        this.nasComparisonData = { ...this.nasComparisonData, ...newData };
        this.renderNasComparison();
    },

    /**
     * 添加新的产品对比（用于后续扩展）
     */
    addNasComparisonProduct(product) {
        this.nasComparisonData.products.push(product);
        this.renderNasComparison();
    },

    /**
     * 添加新的对比特性（用于后续扩展）
     */
    addNasComparisonFeature(feature) {
        this.nasComparisonData.features.push(feature);
        this.renderNasComparison();
    },

    /**
     * 初始化订阅表单
     */
    initSubscribeForm() {
        if (!this.elements.subscribeForm || !this.elements.subscribeBtn) return;

        // 从HTML获取form_id
        const formId = this.elements.subscribeForm.getAttribute('data-id');

        // 订阅表单配置数据
        this.subscribeConfig = {
            email_success_text: "Thank you for subscribing!",
            email_terms_error_text: "Please agree to the terms and conditions.",
            email_input_error_text: "Please enter the correct email address.",
            form_id: formId || "ai-nas-subscribe" // 如果没有data-id则使用默认值
        };

        // 绑定按钮点击事件
        this.elements.subscribeBtn.addEventListener('click', (e) => {
            this.handleSubscribeSubmit(e);
        });

        // 绑定回车键提交
        this.elements.subscribeEmailInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                this.handleSubscribeSubmit(e);
            }
        });
    },

    /**
     * 处理订阅表单提交
     */
    handleSubscribeSubmit(e) {
        e.preventDefault();
        
        // 防止重复提交
        if (this.elements.subscribeBtn.classList.contains('loading')) {
            return false;
        }

        // 清空之前的消息
        this.clearSubscribeMessages();

        // 验证邮箱
        if (!this.elements.subscribeEmailInput.value.trim()) {
            this.showSubscribeError(this.subscribeConfig.email_input_error_text);
            return false;
        }

        // 验证邮箱格式
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.elements.subscribeEmailInput.value.trim())) {
            this.showSubscribeError(this.subscribeConfig.email_input_error_text);
            return false;
        }

        // 验证条款复选框
        if (!this.elements.subscribeTermsCheckbox.checked) {
            this.showSubscribeError(this.subscribeConfig.email_terms_error_text);
            return false;
        }

        // 显示加载状态
        this.setSubscribeLoading(true);

        // 提交表单数据
        this.submitSubscribeForm();
    },

    /**
     * 提交订阅表单到服务器
     */
    submitSubscribeForm() {
        const formData = {
            email: this.elements.subscribeEmailInput.value.trim(),
            accepts_marketing: this.elements.subscribeTermsCheckbox.checked ? "on" : "off",
            form_id: this.subscribeConfig.form_id
        };

        fetch("https://ecf.cirkleinc.com/api/form-submit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            this.setSubscribeLoading(false);
            
            if (data.status === "success") {
                // 清空输入框
                this.elements.subscribeEmailInput.value = "";
                this.elements.subscribeTermsCheckbox.checked = false;
                
                // 显示成功消息
                this.showSubscribeSuccess(this.subscribeConfig.email_success_text);
                
                // GA4 跟踪 (如果存在)
                if (window.ugGa4Track) {
                    window.ugGa4Track.subscriptionEvent({
                        isSuccess: true,
                        position: 'ai-nas-subscribe'
                    });
                }
            } else {
                // 显示错误消息
                const errorMsg = data?.errors?.email?.[0] || data.message || "Something went wrong!";
                this.showSubscribeError(errorMsg);
            }
        })
        .catch(error => {
            this.setSubscribeLoading(false);
            // 静默处理订阅错误
            this.showSubscribeError("Network error. Please try again.");
            
            // GA4 错误跟踪 (如果存在)
            if (window.ugGa4Track) {
                window.ugGa4Track.subscriptionEvent({
                    isSuccess: false,
                    position: 'ai-nas-subscribe'
                });
            }
        });
    },

    /**
     * 设置订阅按钮加载状态
     */
    setSubscribeLoading(isLoading) {
        if (isLoading) {
            this.elements.subscribeBtn.classList.add('loading');
        } else {
            this.elements.subscribeBtn.classList.remove('loading');
        }
    },

    /**
     * 显示订阅成功消息
     */
    showSubscribeSuccess(message) {
        this.clearSubscribeMessages();
        if (this.elements.subscribeSuccessMsg) {
            this.elements.subscribeSuccessMsg.textContent = message;
        }
    },

    /**
     * 显示订阅错误消息
     */
    showSubscribeError(message) {
        this.clearSubscribeMessages();
        if (this.elements.subscribeErrorMsg) {
            this.elements.subscribeErrorMsg.textContent = message;
        }
    },

    /**
     * 清空订阅消息
     */
    clearSubscribeMessages() {
        if (this.elements.subscribeSuccessMsg) {
            this.elements.subscribeSuccessMsg.textContent = "";
        }
        if (this.elements.subscribeErrorMsg) {
            this.elements.subscribeErrorMsg.textContent = "";
        }
    },

    /**
     * 初始化移动端导航功能
     */
    initMobileNavigation() {
        // 延迟绑定以确保DOM完全加载
        setTimeout(() => {
            this.bindMobileDropdownEvents();
        }, 100);
    },

    /**
     * 绑定移动端下拉框事件
     */
    bindMobileDropdownEvents() {
        // 查找所有的箭头按钮和下拉框容器
        const allArrowButtons = document.querySelectorAll('.ug-ai-nas-mobile-nav-arrow-btn');
        const allDropdownContainers = document.querySelectorAll('.ug-ai-nas-mobile-nav-dropdown-container');
        
        // 为每个箭头按钮绑定事件
        for (let i = 0; i < allArrowButtons.length; i++) {
            const arrowButton = allArrowButtons[i];
            // 检查是否已经绑定过事件，避免重复绑定
            if (arrowButton.hasAttribute('data-events-bound')) continue;
            
            // 找到对应的下拉框容器
            const parentContainer = arrowButton.closest('.ug-ai-nas-mobile-nav-dropdown-container');
            if (!parentContainer) continue;
            
            const dropdownContent = parentContainer.querySelector('.ug-ai-nas-mobile-nav-dropdown-content');
            if (!dropdownContent) continue;
            
            // 箭头按钮点击事件
            arrowButton.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                
                // 关闭其他所有下拉框
                this.closeAllMobileDropdowns();
                
                // 切换当前下拉框
                this.toggleSpecificMobileDropdown(parentContainer);
            });
            
            // 下拉菜单项点击事件
            const dropdownItems = dropdownContent.querySelectorAll('.ug-ai-nas-mobile-nav-dropdown-item');
            for (let j = 0; j < dropdownItems.length; j++) {
                const item = dropdownItems[j];
                item.addEventListener('click', (event) => {
                    const target = event.target.getAttribute('data-target');
                    // 这里可以添加具体的导航逻辑
                    
                    // 关闭所有下拉框
                    this.closeAllMobileDropdowns();
                });
            }
            
            // 标记事件已绑定
            arrowButton.setAttribute('data-events-bound', 'true');
        }
        
        // 点击外部关闭所有下拉框
        document.addEventListener('click', (event) => {
            const allDropdownContainers = document.querySelectorAll('.ug-ai-nas-mobile-nav-dropdown-container');
            let isInsideAnyDropdown = false;
            
            // 手动检查是否在任何下拉框内
            for (let i = 0; i < allDropdownContainers.length; i++) {
                if (allDropdownContainers[i].contains(event.target)) {
                    isInsideAnyDropdown = true;
                    break;
                }
            }
            
            if (!isInsideAnyDropdown) {
                this.closeAllMobileDropdowns();
            }
        });
    },

    /**
     * 切换移动端下拉框（保留原方法以兼容性）
     */
    toggleMobileDropdown() {
        const mobileNavSection = document.querySelector('.idx-nas-new-mobile-nav');
        if (!mobileNavSection) return;
        
        const dropdownContainer = mobileNavSection.querySelector('.ug-ai-nas-mobile-nav-dropdown-container');
        if (dropdownContainer) {
            this.toggleSpecificMobileDropdown(dropdownContainer);
        }
    },

    /**
     * 切换特定的移动端下拉框
     */
    toggleSpecificMobileDropdown(container) {
        if (!container) return;
        
        const arrowButton = container.querySelector('.ug-ai-nas-mobile-nav-arrow-btn');
        const dropdownContent = container.querySelector('.ug-ai-nas-mobile-nav-dropdown-content');
        
        if (!arrowButton || !dropdownContent) return;
        
        const isOpen = dropdownContent.classList.contains('ug-ai-nas-open');
        
        if (isOpen) {
            this.closeSpecificMobileDropdown(container);
        } else {
            this.openSpecificMobileDropdown(container);
        }
    },

    /**
     * 打开移动端下拉框（保留原方法以兼容性）
     */
    openMobileDropdown() {
        const mobileNavSection = document.querySelector('.idx-nas-new-mobile-nav');
        if (!mobileNavSection) return;
        
        const dropdownContainer = mobileNavSection.querySelector('.ug-ai-nas-mobile-nav-dropdown-container');
        if (dropdownContainer) {
            this.openSpecificMobileDropdown(dropdownContainer);
        }
    },

    /**
     * 打开特定的移动端下拉框
     */
    openSpecificMobileDropdown(container) {
        if (!container) return;
        
        const arrowButton = container.querySelector('.ug-ai-nas-mobile-nav-arrow-btn');
        const dropdownContent = container.querySelector('.ug-ai-nas-mobile-nav-dropdown-content');
        
        if (!arrowButton || !dropdownContent) return;
        
        dropdownContent.classList.add('ug-ai-nas-open');
        arrowButton.classList.add('ug-ai-nas-active');
    },

    /**
     * 关闭移动端下拉框（保留原方法以兼容性）
     */
    closeMobileDropdown() {
        const mobileNavSection = document.querySelector('.idx-nas-new-mobile-nav');
        if (!mobileNavSection) return;
        
        const dropdownContainer = mobileNavSection.querySelector('.ug-ai-nas-mobile-nav-dropdown-container');
        if (dropdownContainer) {
            this.closeSpecificMobileDropdown(dropdownContainer);
        }
    },

    /**
     * 关闭特定的移动端下拉框
     */
    closeSpecificMobileDropdown(container) {
        if (!container) return;
        
        const arrowButton = container.querySelector('.ug-ai-nas-mobile-nav-arrow-btn');
        const dropdownContent = container.querySelector('.ug-ai-nas-mobile-nav-dropdown-content');
        
        if (!arrowButton || !dropdownContent) return;
        
        dropdownContent.classList.remove('ug-ai-nas-open');
        arrowButton.classList.remove('ug-ai-nas-active');
    },

    /**
     * 关闭所有移动端下拉框
     */
    closeAllMobileDropdowns() {
        const allDropdownContainers = document.querySelectorAll('.ug-ai-nas-mobile-nav-dropdown-container');
        for (let i = 0; i < allDropdownContainers.length; i++) {
            this.closeSpecificMobileDropdown(allDropdownContainers[i]);
        }
    },

    /**
     * 移除移动端导航功能（当切换到桌面端时）
     */
    removeMobileNavFeatures() {
        // 由于下拉框现在通过CSS控制显示隐藏，这里只需要关闭可能打开的下拉框
        this.closeAllMobileDropdowns();
    },

    /**
     * 防抖函数
     */
    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    },

    /**
     * 初始化 sec-all-day 滚动动画
     */
    initSecAllDayAnimations() {
        const section = document.querySelector('.sec-all-day');
        if (!section) return;

        const pageText = section.querySelector('.page-text');
        const animations = section.querySelectorAll('.animation-1');
        const desc = section.querySelector('.desc');
        const stopsList = section.querySelector('.stops-list');
        const video = section.querySelector('video');
        const mask = section.querySelector('.mask');
        const mask1 = section.querySelector('.mask1');

        let videoPlayed = false;

        // 滚动监听函数
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;
            const windowHeight = window.innerHeight;
            
            // 计算滚动进度
            const scrollProgress = Math.max(0, Math.min(1, (scrollY - sectionTop + windowHeight) / (sectionHeight + windowHeight)));
            
            // 文本动画
            if (scrollProgress > 0.2) {
                animations.forEach((el, index) => {
                    setTimeout(() => {
                        el.style.opacity = '1';
                    }, index * 100);
                });
                
                setTimeout(() => {
                    if (desc) desc.style.opacity = '1';
                }, 300);
                
                setTimeout(() => {
                    if (stopsList) stopsList.style.opacity = '1';
                }, 500);
            }

            // 视频播放控制
            if (scrollProgress > 0.3 && !videoPlayed && video) {
                video.play().catch(e => {/* 静默处理视频播放失败 */});
                videoPlayed = true;
            }

            // 文本位置动画
            if (scrollProgress > 0.4 && pageText) {
                const textOffset = Math.max(-200, (scrollProgress - 0.4) * -1000);
                pageText.style.top = `${40 + (textOffset / 10)}%`;
            }

            // 遮罩动画
            if (scrollProgress > 0.2 && scrollProgress < 0.5 && mask) {
                mask.style.opacity = Math.max(0, 1 - (scrollProgress - 0.2) * 1); // 0.7
            }
            if (scrollProgress > 0.5  && mask1) {
                mask.style.opacity = Math.max(0, 0.7 - (scrollProgress - 0.5) * 3);
            }

            

            // if (scrollProgress > 0.4 && mask1) {
            //     mask1.style.opacity = Math.min(1, (scrollProgress - 0.7) * 4);
            // }
        };

        // 绑定滚动事件 - 使用防抖优化性能
        window.addEventListener('scroll', this.debounce(handleScroll, 8));
        
        // 初始化
        handleScroll();

        // 视频播放/暂停控制
        if (video) {
            video.addEventListener('click', () => {
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            });
        }
    },
            /**
     * 初始化 ug-ai-nas__all-day 滚动动画
     */
    initUGAllDayAnimations() {
        const section = document.querySelector('.ug-ai-nas__all-day');
        if (!section) return;

        // 获取所有4个 page-text
        const pageTexts = section.querySelectorAll('.page-text');
        const video = section.querySelector('video');
        const mask = section.querySelector('.mask');
        const mask1 = section.querySelector('.mask1');

        let videoPlayed = false;
        let currentActiveIndex = -1;

        // 滚动监听函数
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;
            const windowHeight = window.innerHeight;
            
            // 计算滚动进度
            const scrollProgress = Math.max(0, Math.min(1, (scrollY - sectionTop + windowHeight) / (sectionHeight + windowHeight)));
            
            // 确定当前应该显示哪个 page-text (将滚动进度分为4个阶段)
            let targetIndex = -1;
            // if (scrollProgress > 0.25 && scrollProgress <= 0.4) {
            //     targetIndex = 0; // 第一个 page-text
            // } else if (scrollProgress > 0.4 && scrollProgress <= 0.55) {
            //     targetIndex = 1; // 第二个 page-text
            // } else if (scrollProgress > 0.55 && scrollProgress <= 0.70) {
            //     targetIndex = 2; // 第三个 page-text
            // }
            if (scrollProgress > 0.35 && scrollProgress <= 0.50) {
                targetIndex = 0; // 第一个 page-text
            } else if (scrollProgress > 0.50 && scrollProgress <= 0.65) {
                targetIndex = 1; // 第二个 page-text
            } else if (scrollProgress > 0.65 && scrollProgress <= 0.80) {
                targetIndex = 2; // 第三个 page-text
            }

            // 如果需要切换活跃的 page-text
            if (targetIndex !== currentActiveIndex) {
                // 隐藏所有 page-text
                pageTexts.forEach((pageText, index) => {
                    pageText.classList.remove('active');
                    
                    // 重置内部动画元素的透明度
                    const animations = pageText.querySelectorAll('.animation-1, .animation-2, .animation-3');
                    const desc = pageText.querySelector('.desc');
                    const stopsList = pageText.querySelector('.stops-list');
                    
                    animations.forEach(el => {
                        el.style.opacity = '0';
                    });
                    if (desc) desc.style.opacity = '0';
                    if (stopsList) stopsList.style.opacity = '0';
                });

                // 显示目标 page-text 并播放动画
                if (targetIndex >= 0 && targetIndex < pageTexts.length) {
                    const activePageText = pageTexts[targetIndex];
                    activePageText.classList.add('active');
                    
                    // 延迟播放内部动画
                    setTimeout(() => {
                        const animations = activePageText.querySelectorAll(`.animation-${targetIndex + 1}`);
                        const desc = activePageText.querySelector('.desc');
                        const stopsList = activePageText.querySelector('.stops-list');
                        
                        // 播放文本动画
                        animations.forEach((el, index) => {
                            setTimeout(() => {
                                el.style.opacity = '1';
                            }, index * 100);
                        });
                        
                        setTimeout(() => {
                            if (desc) desc.style.opacity = '1';
                        }, 300);
                        
                        setTimeout(() => {
                            if (stopsList) stopsList.style.opacity = '1';
                        }, 500);
                    }, 200);
                }

                currentActiveIndex = targetIndex;
            }

            // 视频播放控制
            if (scrollProgress > 0.15 && !videoPlayed && video) {
                video.play().catch(e => {/* 静默处理视频播放失败 */});
                videoPlayed = true;
            }

            // 文本位置动画 - 应用到当前活跃的 page-text
            if (currentActiveIndex >= 0 && currentActiveIndex < pageTexts.length) {
                const activePageText = pageTexts[currentActiveIndex];
                const textOffset = Math.max(-50, (scrollProgress - 0.3) * -200);
                activePageText.style.transform = `translate(-50%, calc(-50% + ${textOffset / 10}px))`;
            }

            // 遮罩动画
            if (scrollProgress > 0.1 && mask) {
                mask.style.opacity = Math.max(0, 1 - (scrollProgress - 0.1) * 1.2);
            }

            // if (scrollProgress > 0.7 && mask1) {
            //     mask1.style.opacity = Math.min(1, (scrollProgress - 0.7) * 3);
            // }
            if (scrollProgress > 0.7 && mask1) {
                mask1.style.opacity = Math.min(1, (scrollProgress - 0.7) * 4);
            }
        };

        // 绑定滚动事件 - 使用防抖优化性能
        window.addEventListener('scroll', this.debounce(handleScroll, 8));
        
        // 初始化
        handleScroll();

        // 视频播放/暂停控制
        if (video) {
            video.addEventListener('click', () => {
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            });
        }
    },

    /**
     * 初始化处理能力描述section动画
     */
    initProcessingDescriptionAnimations() {
        if (!this.elements.processingDescriptionSection) {
            return;
        }

        // 标题和描述文本动画
        gsap.from(this.elements.processingDescriptionTitle, {
            y: 50,
            opacity: 0,
            duration: 0.8,
            ease: "power2.out",
            scrollTrigger: {
                trigger: this.elements.processingDescriptionTitle,
                start: "top 80%",
                end: "bottom 20%",
                toggleActions: "play none none reverse"
            }
        });

        gsap.from(this.elements.processingDescriptionText, {
            y: 30,
            opacity: 0,
            duration: 0.8,
            delay: 0.2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: this.elements.processingDescriptionText,
                start: "top 80%",
                end: "bottom 20%",
                toggleActions: "play none none reverse"
            }
        });

        // 统计卡片动画
        if (this.elements.processingDescriptionStatCards && this.elements.processingDescriptionStatCards.length > 0) {
            // 先设置初始状态
            gsap.set(this.elements.processingDescriptionStatCards, {
                y: 60,
                opacity: 0
            });
            
            // 然后执行动画
            gsap.to(this.elements.processingDescriptionStatCards, {
                y: 0,
                opacity: 1,
                duration: 0.8,
                stagger: 0.15,
                ease: "back.out(1.7)",
                scrollTrigger: {
                    trigger: this.elements.processingDescriptionStatCards[0],
                    start: "top 80%",
                    end: "bottom 20%",
                    toggleActions: "play none none reverse"
                }
            });

            // 数字计数动画
            this.elements.processingDescriptionStatCards.forEach((card, index) => {
                this.addProcessingDescriptionCountUp(card, index);
            });
        }
    },

    /**
     * 为处理能力描述统计卡片添加数字计数动画
     */
    addProcessingDescriptionCountUp(card, index) {
        const numberElement = card.querySelector('.ug-ai-nas__processing-description-stat-number');
        if (!numberElement) return;

        const finalValue = numberElement.textContent;
        let startValue = 0;
        let endValue = 0;

        // 解析数值
        if (finalValue.includes('.')) {
            endValue = parseFloat(finalValue);
            startValue = 0;
        } else if (finalValue === 'xx') {
            return; // 跳过非数字值
        } else {
            endValue = parseInt(finalValue);
            startValue = 0;
        }

        // 设置初始值
        numberElement.textContent = startValue.toString();

        // 创建计数动画
        const countAnimation = { value: startValue };
        
        gsap.to(countAnimation, {
            value: endValue,
            duration: 2,
            ease: "power2.out",
            delay: 0.5 + (index * 0.2),
            onUpdate: function() {
                if (finalValue.includes('.')) {
                    numberElement.textContent = countAnimation.value.toFixed(1);
                } else {
                    numberElement.textContent = Math.round(countAnimation.value).toString();
                }
            },
            onComplete: function() {
                numberElement.textContent = finalValue;
            },
            scrollTrigger: {
                trigger: card,
                start: "top 80%",
                toggleActions: "play none none none"
            }
        });
    },

    /**
     * 初始化特色功能轮播图
     */
    initSpecialSlider() {
        if (!this.elements.specialSwiper) return;

        // 初始化 Swiper
        const specialSwiper = new Swiper('.idx-nas-new-special-swiper', {
            slidesPerView: 'auto',
            spaceBetween: 20,
            speed: 800,
            grabCursor: true,
            navigation: {
                nextEl: '.idx-nas-new-special .swiper-button-next',
                prevEl: '.idx-nas-new-special .swiper-button-prev',
            },
            effect: 'slide',
            cssMode: false,
            mousewheel: {
                forceToAxis: true
            }
        });
    },

    initVideoHandlers() {
        // 初始化所有视频播放按钮
        if (this.elements.videoPlayBtns) {
            this.elements.videoPlayBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    const videoUrl = btn.getAttribute('data-video-url');
                    if (videoUrl) {
                        this.openVideoModal(videoUrl);
                    }
                });
            });
        }

        // 初始化关闭按钮
        if (this.elements.videoModalCloseBtn) {
            this.elements.videoModalCloseBtn.addEventListener('click', (e) => {
                e.stopPropagation(); // 阻止事件冒泡
                this.closeVideoModal();
            });
        }

        // 点击弹窗内容区域外关闭
        if (this.elements.videoModal) {
            this.elements.videoModal.addEventListener('click', (e) => {
                // 如果点击的是弹窗本身或遮罩层，则关闭弹窗
                if (e.target === this.elements.videoModal || 
                    e.target.classList.contains('ug-video-modal__overlay') ||
                    e.target.classList.contains('ug-video-modal__container')) {
                    this.closeVideoModal();
                }
            });
        }

        // ESC键关闭
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.elements.videoModal.classList.contains('active')) {
                this.closeVideoModal();
            }
        });
    },

    initSwipers() {
        try {
            // 检查Swiper库是否已加载
            if (typeof Swiper === 'undefined') {
                setTimeout(() => this.initSwipers(), 500);
                return;
            }
            
        // 特色功能轮播
        this.initSpecialSlider();
            
        // Features Showcase
        this.initFeaturesShowcase();
            
        } catch (error) {
            // 错误情况下重试
            setTimeout(() => this.initSwipers(), 1000);
        }
    },

    /**
     * 初始化Features Showcase联动效果
     */
    initFeaturesShowcase() {
        if (!this.elements.featuresImageSwiper || !this.elements.featuresTitleSwiper) return;

        let imageSwiper, titleSwiper;

        // 更新导航按钮显示状态
        const updateNavigationVisibility = (swiper) => {
            const prevButton = document.querySelector('.ug-ai-nas__titles-prev');
            const nextButton = document.querySelector('.ug-ai-nas__titles-next');
            
            if (prevButton) {
                prevButton.style.display = swiper.isBeginning ? 'none' : 'flex';
            }
            
            if (nextButton) {
                nextButton.style.display = swiper.isEnd ? 'none' : 'flex';
            }
        };

        // 更新活动标题样式
        const updateActiveTitle = (index) => {
            if (!this.elements.featureTitles) return;
            
            this.elements.featureTitles.forEach((title, i) => {
                if (i === index) {
                    title.classList.add('active');
                } else {
                    title.classList.remove('active');
                }
            });

            // 更新描述的显示状态
            const desItems = document.querySelectorAll('.ug-ai-nas__features-des-item');
            if (desItems) {
                desItems.forEach((item, i) => {
                    if (i === index) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                });
            }
        };

        // 初始化图片轮播
        imageSwiper = new Swiper(this.elements.featuresImageSwiper, {
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            allowTouchMove: false,
            preventInteractionOnTransition: true,
            effect: 'slide',
            on: {
                slideChange: function() {
                    const currentIndex = this.activeIndex;
                    updateActiveTitle(currentIndex);
                }
            }
        });

        // 初始化标题轮播
        titleSwiper = new Swiper(this.elements.featuresTitleSwiper, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            speed: 800,
            watchSlidesProgress: true,
            preventInteractionOnTransition: false,
            slideToClickedSlide: false,
            touchRatio: 1,
            navigation: {
                nextEl: '.ug-ai-nas__titles-next',
                prevEl: '.ug-ai-nas__titles-prev',
            },
            breakpoints: {
                768: {
                    spaceBetween: 36,
                }
            },
            on: {
                init: function() {
                    updateNavigationVisibility(this);
                },
                slideChange: function() {
                    updateNavigationVisibility(this);
                }
            }
        });

        // 点击标题切换图片和更新状态
        if (this.elements.featureTitles) {
            this.elements.featureTitles.forEach((title, index) => {
                title.addEventListener('click', () => {
                    // 切换图片
                    imageSwiper.slideTo(index);
                    // 更新标题高亮状态和描述显示
                    updateActiveTitle(index);
                    // 滚动标题到对应位置
                    titleSwiper.slideTo(index);
                });
            });
        }

        // 初始化第一个标题和描述为活动状态
        updateActiveTitle(0);

        // 添加hover效果
        const featureImages = document.querySelectorAll('.ug-ai-nas__feature-image');
        if (featureImages) {
            featureImages.forEach(image => {
                const img = image.querySelector('img');
                if (!img) return;

                image.addEventListener('mouseenter', () => {
                    gsap.to(img, {
                        scale: 1.05,
                        duration: 0.6,
                        ease: 'power2.out'
                    });
                });

                image.addEventListener('mouseleave', () => {
                    gsap.to(img, {
                        scale: 1,
                        duration: 0.6,
                        ease: 'power2.out'
                    });
                });
            });
        }
    },
        /**
     * Simplified Setup Section动画
     */
    initSimplifiedSetupAnimations() {
        if (!this.elements.simplifiedSetupSection) return;

        // 初始化Simplified Setup动画 (DE版本)

        // 清理现有的ScrollTrigger实例
        this._cleanupSimplifiedSetupTriggers();

        const isMobile = window.innerWidth <= 768;

        // 确保在下一帧进行初始化，让DOM有时间渲染
        requestAnimationFrame(() => {
            // 刷新ScrollTrigger以重新计算位置
            ScrollTrigger.refresh();
            
            setTimeout(() => {
        // 主内容区域动画
        this.animateSimplifiedSetupMain();
        
        // 功能特性动画
        this.animateSimplifiedSetupFeatures();
        
        // 指示器动画
        this.animateSimplifiedSetupIndicators();
        
        // PC端交互功能
        if (!isMobile) {
            this.initSimplifiedSetupInteractions();
        }

                // Simplified Setup动画初始化完成
            }, 100);
        });
    },

    /**
     * 清理Simplified Setup相关的ScrollTrigger
     */
    _cleanupSimplifiedSetupTriggers() {
        const triggers = ScrollTrigger.getAll();
        triggers.forEach(trigger => {
            if (trigger.trigger && (
                trigger.trigger.closest('.ug-ai-nas__simplified-setup-container') ||
                trigger.trigger.classList.contains('ug-ai-nas__simplified-setup-main') ||
                trigger.trigger.classList.contains('ug-ai-nas__simplified-setup-feature') ||
                trigger.trigger.classList.contains('ug-ai-nas__simplified-setup-indicator')
            )) {
                trigger.kill();
                // 清理Simplified Setup触发器
            }
        });
    },

    /**
     * 主内容区域动画
     */
    animateSimplifiedSetupMain() {
        if (!this.elements.simplifiedSetupMain) return;

        // 重置元素状态
        gsap.set(this.elements.simplifiedSetupMain, {
                opacity: 0,
                y: 60
        });

        const animation = gsap.to(this.elements.simplifiedSetupMain, {
                opacity: 1,
                y: 0,
                duration: 1.2,
                ease: this.config.easeDefault,
            paused: true
        });

        ScrollTrigger.create({
                    trigger: this.elements.simplifiedSetupMain,
            start: 'top 85%',
            end: 'bottom 15%',
            onEnter: () => {
                // 触发Simplified Setup主内容动画
                animation.restart();
            },
            onRefresh: () => {
                // 检查元素是否应该显示但未触发动画
                const rect = this.elements.simplifiedSetupMain.getBoundingClientRect();
                const isInViewport = rect.top < window.innerHeight * 0.85;
                const currentOpacity = window.getComputedStyle(this.elements.simplifiedSetupMain).opacity;
                
                if (isInViewport && currentOpacity === '0') {
                    // 修复Simplified Setup主内容显示状态
                    animation.restart();
                }
            },
            refreshPriority: 0,
            id: 'simplifiedSetupMain'
        });
    },

    /**
     * 功能特性动画
     */
    animateSimplifiedSetupFeatures() {
        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            // 移动端动画 - 每个特性元素单独设置相同的动画
            if (this.elements.simplifiedSetupFeaturesMobile.length > 0) {
                this.elements.simplifiedSetupFeaturesMobile.forEach((feature) => {
                    gsap.fromTo(feature,
                        {
                            opacity: 0,
                            y: 30
                        },
                        {
                            opacity: 1,
                            y: 0,
                            duration: this.config.animationDuration,
                            ease: this.config.easeDefault,
                            scrollTrigger: {
                                trigger: feature,
                                start: 'top 85%',
                                toggleActions: 'play none none reverse'
                            }
                        }
                    );
                });
            }

            if (this.elements.simplifiedSetupImagesMobile.length > 0) {
                this.elements.simplifiedSetupImagesMobile.forEach((image) => {
                    gsap.fromTo(image,
                        {
                            opacity: 0,
                            scale: 0.9
                        },
                        {
                            opacity: 1,
                            scale: 1,
                            duration: this.config.animationDuration,
                            ease: this.config.easeDefault,
                            scrollTrigger: {
                                trigger: image,
                                start: 'top 85%',
                                toggleActions: 'play none none reverse'
                            }
                        }
                    );
                });
            }
        } else {
            // PC端动画
            this.elements.simplifiedSetupFeatures.forEach((feature, index) => {
                gsap.fromTo(feature,
                    {
                        opacity: 0,
                        x: 30
                    },
                    {
                        opacity: 1,
                        x: 0,
                        duration: this.config.animationDuration,
                        delay: index * this.config.staggerDelay * 2,
                        ease: this.config.easeDefault,
                        scrollTrigger: {
                            trigger: feature,
                            start: 'top 85%',
                            toggleActions: 'play none none reverse'
                        }
                    }
                );
            });

            // 分割线动画
            if (this.elements.simplifiedSetupContentInner) {
                ScrollTrigger.create({
                    trigger: this.elements.simplifiedSetupContentInner,
                    start: 'top 85%',
                    toggleActions: 'play none none reverse',
                    onEnter: () => {
                        setTimeout(() => {
                            this.elements.simplifiedSetupContentInner.classList.add('animated');
                        }, 500);
                    },
                    onLeaveBack: () => {
                        this.elements.simplifiedSetupContentInner.classList.remove('animated');
                    }
                });
            }
        }
    },

    /**
     * 指示器动画
     */
    animateSimplifiedSetupIndicators() {
        this.elements.simplifiedSetupIndicators.forEach(indicator => {
            // 指示器图标脉冲动画
            const icon = indicator.querySelector('.ug-ai-nas__simplified-setup-indicator-icon');
            if (icon) {
                gsap.to(icon, {
                    scale: 1.1,
                    duration: 1,
                    ease: 'power2.inOut',
                    yoyo: true,
                    repeat: -1
                });
            }

            // 指示器渐入动画
            gsap.fromTo(indicator,
                {
                    opacity: 0,
                    y: 20
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    ease: this.config.easeDefault,
                    scrollTrigger: {
                        trigger: indicator,
                        start: 'top 90%',
                        toggleActions: 'play none none reverse'
                    }
                }
            );
        });
    },

    /**
     * PC端交互功能
     */
    initSimplifiedSetupInteractions() {
        if (this.elements.simplifiedSetupFeatures.length === 0 || this.elements.simplifiedSetupImages.length === 0) return;

        // 设置初始状态 - 隐藏除第一张外的所有图片
        this.elements.simplifiedSetupImages.forEach((img, index) => {
            if (index === 0) {
                img.style.opacity = '1';
                img.style.zIndex = '2';
            } else {
                img.style.opacity = '0';
                img.style.zIndex = '1';
            }
            img.style.transition = 'opacity 0.4s ease-in-out';
        });

        // 为功能特性添加点击事件
        this.elements.simplifiedSetupFeatures.forEach((feature, index) => {
            feature.addEventListener('click', () => {
                // 移除所有功能的active类
                this.elements.simplifiedSetupFeatures.forEach(f => f.classList.remove('active'));
                
                // 为点击的功能添加active类
                feature.classList.add('active');
                
                // 切换对应的图片
                this.elements.simplifiedSetupImages.forEach((img, imgIndex) => {
                    if (imgIndex === index) {
                        img.style.opacity = '1';
                        img.style.zIndex = '2';
                    } else {
                        img.style.opacity = '0';
                        img.style.zIndex = '1';
                    }
                });
            });

            // 设置光标样式
            feature.style.cursor = 'pointer';
        });
    },



    /**
     * 初始化Simplified Setup（保持向后兼容）
     */
    initSimplifiedSetup() {
        // 检查section是否存在
        if (!this.elements.simplifiedSetupSection) return;
        
        // 调用新的动画初始化方法
        this.initSimplifiedSetupAnimations();
    },

    /**
     * Processing Power标题动画
     */
    animateProcessingPowerTitle() {
        if (!this.elements.processingPowerTitle) return;

        gsap.fromTo(this.elements.processingPowerTitle,
            {
                opacity: 0,
                y: 50,
                scale: 0.95
            },
            {
                opacity: 1,
                y: 0,
                scale: 1,
                duration: 1.2,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: this.elements.processingPowerTitle,
                    start: 'top 80%',
                    toggleActions: 'play none none reverse'
                }
            }
        );
    },

    /**
     * Processing Power PC端动画
     */
    animateProcessingPowerPC() {
        if (!this.elements.processingPowerMain) return;

        // 主容器动画
        gsap.fromTo(this.elements.processingPowerMain,
            {
                opacity: 0,
                scale: 0.95,
                y: 30
            },
            {
                opacity: 1,
                scale: 1,
                y: 0,
                duration: 1,
                ease: this.config.easeDefault,
                scrollTrigger: {
                    trigger: this.elements.processingPowerMain,
                    start: 'top 80%',
                    toggleActions: 'play none none reverse'
                }
            }
        );

        // 左侧文本内容动画
        if (this.elements.processingPowerSubtitle) {
            gsap.fromTo(this.elements.processingPowerSubtitle,
                {
                    opacity: 0,
                    x: -50
                },
                {
                    opacity: 1,
                    x: 0,
                    duration: this.config.animationDuration,
                    delay: 0.3,
                    ease: this.config.easeDefault,
                    scrollTrigger: {
                        trigger: this.elements.processingPowerMain,
                        start: 'top 80%',
                        toggleActions: 'play none none reverse'
                    }
                }
            );
        }

        if (this.elements.processingPowerDescription) {
            gsap.fromTo(this.elements.processingPowerDescription,
                {
                    opacity: 0,
                    x: -50
                },
                {
                    opacity: 1,
                    x: 0,
                    duration: this.config.animationDuration,
                    delay: 0.5,
                    ease: this.config.easeDefault,
                    scrollTrigger: {
                        trigger: this.elements.processingPowerMain,
                        start: 'top 80%',
                        toggleActions: 'play none none reverse'
                    }
                }
            );
        }

        // 右侧统计卡片动画
        this.elements.processingPowerStatCards.forEach((card, index) => {
            gsap.fromTo(card,
                {
                    opacity: 0,
                    x: 50,
                    scale: 0.9
                },
                {
                    opacity: 1,
                    x: 0,
                    scale: 1,
                    duration: this.config.animationDuration,
                    delay: 0.7 + index * 0.1,
                    ease: this.config.easeBack,
                    scrollTrigger: {
                        trigger: this.elements.processingPowerMain,
                        start: 'top 80%',
                        toggleActions: 'play none none reverse'
                    }
                }
            );

            // 添加悬停效果
            this.addProcessingPowerCardHoverEffect(card);
            
            // 数字计数动画
            this.animateProcessingPowerCountUp(card, index);
        });
    },

    /**
     * Processing Power移动端动画
     */
    animateProcessingPowerMobile() {
        if (!this.elements.processingPowerMobile) return;

        // 移动端容器动画
        gsap.fromTo(this.elements.processingPowerMobile,
            {
                opacity: 0,
                y: 30
            },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: this.config.easeDefault,
                scrollTrigger: {
                    trigger: this.elements.processingPowerMobile,
                    start: 'top 80%',
                    toggleActions: 'play none none reverse'
                }
            }
        );

        // 移动端文本动画
        if (this.elements.processingPowerMobileSubtitle) {
            gsap.fromTo(this.elements.processingPowerMobileSubtitle,
                {
                    opacity: 0,
                    y: 30
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: this.config.animationDuration,
                    delay: 0.3,
                    ease: this.config.easeDefault,
                    scrollTrigger: {
                        trigger: this.elements.processingPowerMobile,
                        start: 'top 80%',
                        toggleActions: 'play none none reverse'
                    }
                }
            );
        }

        if (this.elements.processingPowerMobileDescription) {
            gsap.fromTo(this.elements.processingPowerMobileDescription,
                {
                    opacity: 0,
                    y: 30
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: this.config.animationDuration,
                    delay: 0.5,
                    ease: this.config.easeDefault,
                    scrollTrigger: {
                        trigger: this.elements.processingPowerMobile,
                        start: 'top 80%',
                        toggleActions: 'play none none reverse'
                    }
                }
            );
        }

        // 移动端统计卡片动画
        this.elements.processingPowerMobileStatCards.forEach((card, index) => {
            gsap.fromTo(card,
                {
                    opacity: 0,
                    y: 30,
                    scale: 0.9
                },
                {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    duration: this.config.animationDuration,
                    delay: 0.7 + index * 0.1,
                    ease: this.config.easeBack,
                    scrollTrigger: {
                        trigger: this.elements.processingPowerMobile,
                        start: 'top 80%',
                        toggleActions: 'play none none reverse'
                    }
                }
            );

            // 移动端数字计数动画
            this.animateProcessingPowerMobileCountUp(card, index);
        });
    },

    /**
     * Processing Power卡片悬停效果
     */
    addProcessingPowerCardHoverEffect(card) {
        const number = card.querySelector('.ug-ai-nas__processing-power-stat-number');

        card.addEventListener('mouseenter', () => {
            gsap.to(card, { 
                y: -8, 
                scale: 1.05, 
                duration: 0.3, 
                ease: this.config.easeDefault 
            });
            if (number) {
                gsap.to(number, { 
                    scale: 1.1, 
                    duration: 0.3, 
                    ease: this.config.easeDefault 
                });
            }
        });

        card.addEventListener('mouseleave', () => {
            gsap.to(card, { 
                y: 0, 
                scale: 1, 
                duration: 0.3, 
                ease: this.config.easeDefault 
            });
            if (number) {
                gsap.to(number, { 
                    scale: 1, 
                    duration: 0.3, 
                    ease: this.config.easeDefault 
                });
            }
        });
    },

    /**
     * Processing Power数字计数动画（PC端）
     */
    animateProcessingPowerCountUp(card, index) {
        const numberElement = card.querySelector('.ug-ai-nas__processing-power-stat-number');
        if (!numberElement) return;

        const originalText = numberElement.textContent;
        
        // 处理不同类型的数字
        if (originalText === 'xx') {
            // 对于 "xx" 不做计数动画
            return;
        }

        const targetNumber = parseFloat(originalText);
        if (isNaN(targetNumber)) return;

        const countObj = { value: 0 };
        gsap.to(countObj, {
            value: targetNumber,
            duration: 2,
            ease: "power2.out",
            delay: index * 0.2 + 1,
            onUpdate: () => {
                // 根据原始数字格式化显示
                if (originalText.includes('.')) {
                    numberElement.textContent = countObj.value.toFixed(2);
                } else {
                    numberElement.textContent = Math.floor(countObj.value).toString();
                }
            }
        });
    },

    /**
     * Processing Power数字计数动画（移动端）
     */
    animateProcessingPowerMobileCountUp(card, index) {
        const numberElement = card.querySelector('.ug-ai-nas__processing-power-mobile-stat-number');
        if (!numberElement) return;

        const originalText = numberElement.textContent;
        
        // 处理不同类型的数字
        if (originalText === 'xx') {
            // 对于 "xx" 不做计数动画
            return;
        }

        const targetNumber = parseFloat(originalText);
        if (isNaN(targetNumber)) return;

        const countObj = { value: 0 };
        gsap.to(countObj, {
            value: targetNumber,
            duration: 2,
            ease: "power2.out",
            delay: index * 0.2 + 1,
            onUpdate: () => {
                // 根据原始数字格式化显示
                if (originalText.includes('.')) {
                    numberElement.textContent = countObj.value.toFixed(2);
                } else {
                    numberElement.textContent = Math.floor(countObj.value).toString();
                }
            }
        });
    },

    /**
     * 初始化超级流畅多任务处理动画 - 使用滚动监听
     */
    initSuperSmoothMultitaskingAnimations() {
        if (!this.elements.superSmoothMultitaskingSection) {
            return;
        }

        // 初始化 Super-Smooth Multitasking 动画

        // 缓存DOM元素
        this.multitaskingElements = {
            section: this.elements.superSmoothMultitaskingSection,
            container1: document.querySelector('.multitasking-container1'),
            container2: document.querySelector('.multitasking-container2'),
            bg1: document.querySelector('.multitasking-container1 .ug-ai-nas__super-smooth-multitasking-bg'),
            bg2: document.querySelector('.multitasking-container2 .ug-ai-nas__super-smooth-multitasking-bg'),
            subtitle1: document.querySelector('.multitasking-container1 .ug-ai-nas__super-smooth-multitasking-subtitle'),
            subtitle2: document.querySelector('.multitasking-container2 .ug-ai-nas__super-smooth-multitasking-subtitle'),
            title1: document.querySelector('.multitasking-container1 .ug-ai-nas__super-smooth-multitasking-title'),
            title2: document.querySelector('.multitasking-container2 .ug-ai-nas__super-smooth-multitasking-title'),
            numberContent: document.querySelector('.multitasking-container1 .ug-ai-nas__super-smooth-multitasking-content-number-content'),
            desc2: document.querySelector('.multitasking-container2 .ug-ai-nas__super-smooth-multitasking-desc'),
            progressBars: document.querySelectorAll('.multitasking-container1 .ug-ai-nas__super-smooth-multitasking-content-number-content-number-line-progress')
        };

        // 设置初始状态
        this.setSuperSmoothMultitaskingInitialState();

        // 创建滚动监听器
        this.createSuperSmoothMultitaskingScrollListener();

        // 添加交互效果
        this.addSuperSmoothMultitaskingInteractions();
    },

    /**
     * 设置超级流畅多任务处理初始状态 - 滚动监听版本
     */
    setSuperSmoothMultitaskingInitialState() {
        // 初始化状态标志
        this.multitaskingState = {
            container1Animated: false,
            container2Animated: false,
            lastScrollY: 0,
            firstScroll: true
        };

        // Container 1 - 初始显示
        if (this.multitaskingElements.container1) {
            gsap.set(this.multitaskingElements.container1, { opacity: 1 });
            
            // Container 1 内容初始状态
            gsap.set([
                this.multitaskingElements.bg1,
                this.multitaskingElements.subtitle1,
                this.multitaskingElements.title1,
                this.multitaskingElements.numberContent
            ], {
                opacity: 0,
                y: 50
            });

            // 进度条初始宽度
            if (this.multitaskingElements.progressBars) {
                gsap.set(this.multitaskingElements.progressBars, { width: '0%' });
            }
        }

        // Container 2 - 初始隐藏
        if (this.multitaskingElements.container2) {
            gsap.set(this.multitaskingElements.container2, { opacity: 0 });
            
            // Container 2 内容初始状态
            gsap.set([
                this.multitaskingElements.bg2,
                this.multitaskingElements.subtitle2,
                this.multitaskingElements.title2,
                this.multitaskingElements.desc2
            ], {
                opacity: 0,
                y: 50
            });
        }

        // Super-Smooth Multitasking initial state set
    },

    /**
     * 创建超级流畅多任务处理滚动监听器
     * 使用原生滚动事件代替pin，通过监听section滚动进度控制动画
     */
    createSuperSmoothMultitaskingScrollListener() {
        const section = this.multitaskingElements.section;
        
        // 防抖函数
        let ticking = false;
        
        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    this.updateMultitaskingOnScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };

        // 监听滚动事件
        window.addEventListener('scroll', handleScroll, { passive: true });
        
        // 初始检查
        setTimeout(() => {
            this.updateMultitaskingOnScroll();
        }, 100);

        // Super-Smooth Multitasking scroll listener created
    },

    /**
     * 滚动时更新多任务处理动画
     */
    updateMultitaskingOnScroll() {
        const section = this.multitaskingElements.section;
        if (!section) return;

        // 计算section相对于视口的位置
        const rect = section.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const sectionHeight = section.offsetHeight;
        
        // 计算滚动进度 (0-1)
        // 当section顶部距离视口底部80%时开始计算进度
        // 当section底部离开视口时进度为1
        let progress = 0;
        
        // 当section进入视口80%时开始动画
        const triggerPoint = windowHeight * 0.85;
        
        if (rect.top <= triggerPoint) {
            // section已经开始进入视口的触发区域
            const scrolledDistance = triggerPoint - rect.top;
            const totalScrollDistance = sectionHeight + (windowHeight - triggerPoint);
            progress = Math.min(scrolledDistance / totalScrollDistance, 1);
        }
        
        // 限制进度范围
        progress = Math.max(0, Math.min(1, progress));
        
        // console.log(`Scroll progress: ${(progress * 100).toFixed(1)}%`);
        
        // 根据进度控制容器显示和动画
        this.controlContainersByProgress(progress);
    },
    
        /**
     * 根据滚动进度控制容器显示和动画
     */
        controlContainersByProgress(progress) {
            // 定义动画触发点
            const CONTAINER_1_START = 0.1;    // Container 1 开始动画
            const CONTAINER_2_START = 0.5;    // Container 2 开始动画
            
            // 控制容器的显示/隐藏
            const showContainer1 = progress < CONTAINER_2_START;
            const showContainer2 = progress >= CONTAINER_2_START;
            
            // 确保 Container 1 初始可见
            if (this.multitaskingElements.container1 && this.multitaskingState.firstScroll) {
                gsap.set(this.multitaskingElements.container1, { opacity: 1 });
                this.multitaskingState.firstScroll = false;
            }
            
            // 控制 Container 1 的显示/隐藏
            if (this.multitaskingElements.container1) {
                const targetOpacity1 = showContainer1 ? 1 : 0;
                const currentOpacity1 = gsap.getProperty(this.multitaskingElements.container1, "opacity");
                
                if (Math.abs(currentOpacity1 - targetOpacity1) > 0.1) {
                    gsap.to(this.multitaskingElements.container1, { 
                        opacity: targetOpacity1, 
                        duration: 0.5,
                        ease: "power2.out"
                    });
                }
            }
            
            // 控制 Container 2 的显示/隐藏
            if (this.multitaskingElements.container2) {
                const targetOpacity2 = showContainer2 ? 1 : 0;
                const currentOpacity2 = gsap.getProperty(this.multitaskingElements.container2, "opacity");
                
                if (Math.abs(currentOpacity2 - targetOpacity2) > 0.1) {
                    gsap.to(this.multitaskingElements.container2, { 
                        opacity: targetOpacity2, 
                        duration: 0.5,
                        ease: "power2.out"
                    });
                }
            }
            
            // 触发Container 1 动画
            if (progress >= CONTAINER_1_START && !this.multitaskingState.container1Animated) {
                this.multitaskingState.container1Animated = true;
                this.animateContainer1();
            }
            
            // 触发Container 2 动画
            if (progress >= CONTAINER_2_START && !this.multitaskingState.container2Animated) {
                this.multitaskingState.container2Animated = true;
                this.animateContainer2();
            }
            
            // 重置动画状态（向上滚动时）
            if (progress < CONTAINER_1_START && this.multitaskingState.container1Animated) {
                this.resetAnimationState();
            }
        },



     /**
      * 重置动画状态
      */
     resetAnimationState() {
                     // Resetting multitasking animation state
         
         this.multitaskingState.container1Animated = false;
         this.multitaskingState.container2Animated = false;
         
         // 只重置内容元素到初始状态，但保持容器和背景的可见性
         this.resetContentToInitialState();
     },

     /**
      * 重置内容到初始状态（不影响已显示的元素可见性）
      */
     resetContentToInitialState() {
         // Container 1 - 保持容器可见
         if (this.multitaskingElements.container1) {
             gsap.set(this.multitaskingElements.container1, { opacity: 1 });
         }

         // Container 2 - 保持隐藏状态
         if (this.multitaskingElements.container2) {
             gsap.set(this.multitaskingElements.container2, { opacity: 0 });
             
             // Container 2 内容初始状态
             gsap.set([
                 this.multitaskingElements.bg2,
                 this.multitaskingElements.subtitle2,
                 this.multitaskingElements.title2,
                 this.multitaskingElements.desc2
             ], {
                 opacity: 0,
                 y: 50
             });
         }

         // Animation state reset (preserving visible elements)
     },
     
          
    
    /**
     * Container 1 动画 - 滚动监听版本
     */
    animateContainer1() {
        // Starting Container 1 animations
        
        // 背景图动画 - 只在第一次时从隐藏状态开始动画，后续保持可见
        if (this.multitaskingElements.bg1) {
            const currentOpacity = gsap.getProperty(this.multitaskingElements.bg1, "opacity");
            if (currentOpacity === 0) {
                gsap.fromTo(this.multitaskingElements.bg1, 
                    { opacity: 0, y: 50 },
                    { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
                );
            } else {
                // 背景已经可见，确保它保持可见状态
                gsap.set(this.multitaskingElements.bg1, { opacity: 1 });
            }
        }
        
        // 副标题动画 - 只在第一次时执行动画，后续保持可见
        if (this.multitaskingElements.subtitle1) {
            const currentOpacity = gsap.getProperty(this.multitaskingElements.subtitle1, "opacity");
            if (currentOpacity === 0) {
                gsap.fromTo(this.multitaskingElements.subtitle1,
                    { opacity: 0, y: 30 },
                    { opacity: 1, y: 0, duration: 0.8, delay: 0.2, ease: "power2.out" }
                );
            } else {
                gsap.set(this.multitaskingElements.subtitle1, { opacity: 1 });
            }
        }
        
        // 标题动画 - 只在第一次时执行动画，后续保持可见
        if (this.multitaskingElements.title1) {
            const currentOpacity = gsap.getProperty(this.multitaskingElements.title1, "opacity");
            if (currentOpacity === 0) {
                gsap.fromTo(this.multitaskingElements.title1,
                    { opacity: 0, y: 30 },
                    { opacity: 1, y: 0, duration: 0.8, delay: 0.4, ease: "power2.out" }
                );
            } else {
                gsap.set(this.multitaskingElements.title1, { opacity: 1 });
            }
        }
        
        // 数字内容动画 - 只在第一次时执行动画，后续保持可见
        if (this.multitaskingElements.numberContent) {
            const currentOpacity = gsap.getProperty(this.multitaskingElements.numberContent, "opacity");
            if (currentOpacity === 0) {
                gsap.fromTo(this.multitaskingElements.numberContent,
                    { opacity: 0, y: 30 },
                    { 
                        opacity: 1, 
                        y: 0, 
                        duration: 0.8, 
                        delay: 0.6, 
                        ease: "power2.out",
                        onComplete: () => {
                            // 进度条动画
                            if (this.multitaskingElements.progressBars) {
                                gsap.to(this.multitaskingElements.progressBars, {
                                    width: (index) => index === 0 ? '100%' : '80%',
                                    duration: 1.2,
                                    ease: "power2.out",
                                    stagger: 0.2
                                });
                            }
                        }
                    }
                );
            } else {
                gsap.set(this.multitaskingElements.numberContent, { opacity: 1 });
                // 确保进度条也保持正确状态
                if (this.multitaskingElements.progressBars) {
                    gsap.set(this.multitaskingElements.progressBars, {
                        width: (index) => index === 0 ? '100%' : '80%'
                    });
                }
            }
        }
    },
    
    /**
     * Container 2 动画 - 滚动监听版本
     */
    animateContainer2() {
        // Starting Container 2 animations
        
        // Container 2 背景图动画
        if (this.multitaskingElements.bg2) {
            gsap.fromTo(this.multitaskingElements.bg2,
                { opacity: 0, y: 50 },
                { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
            );
        }
        
        // Container 2 副标题动画
        if (this.multitaskingElements.subtitle2) {
            gsap.fromTo(this.multitaskingElements.subtitle2,
                { opacity: 0, y: 30 },
                { opacity: 1, y: 0, duration: 0.8, delay: 0.2, ease: "power2.out" }
            );
        }
        
        // Container 2 标题动画
        if (this.multitaskingElements.title2) {
            gsap.fromTo(this.multitaskingElements.title2,
                { opacity: 0, y: 30 },
                { opacity: 1, y: 0, duration: 0.8, delay: 0.4, ease: "power2.out" }
            );
        }
        
        // Container 2 描述动画
        if (this.multitaskingElements.desc2) {
            gsap.fromTo(this.multitaskingElements.desc2,
                { opacity: 0, y: 30 },
                { opacity: 1, y: 0, duration: 0.8, delay: 0.6, ease: "power2.out" }
            );
        }
    },
    








    /**
     * 添加超级流畅多任务处理交互效果 - 滚动监听版本
     */
    addSuperSmoothMultitaskingInteractions() {
        // Container 1 悬停效果
        if (this.multitaskingElements.container1 && this.multitaskingElements.bg1) {
            this.multitaskingElements.container1.addEventListener('mouseenter', () => {
                gsap.to(this.multitaskingElements.bg1, {
                    scale: 1.02,
                    duration: 0.3,
                    ease: "power2.out"
                });
            });

            this.multitaskingElements.container1.addEventListener('mouseleave', () => {
                gsap.to(this.multitaskingElements.bg1, {
                    scale: 1,
                    duration: 0.3,
                    ease: "power2.out"
                });
            });
        }

        // Container 2 悬停效果
        if (this.multitaskingElements.container2 && this.multitaskingElements.bg2) {
            this.multitaskingElements.container2.addEventListener('mouseenter', () => {
                gsap.to(this.multitaskingElements.bg2, {
                    scale: 1.02,
                    duration: 0.3,
                    ease: "power2.out"
                });
            });

            this.multitaskingElements.container2.addEventListener('mouseleave', () => {
                gsap.to(this.multitaskingElements.bg2, {
                    scale: 1,
                    duration: 0.3,
                    ease: "power2.out"
                });
            });
        }

        // 进度条悬停效果
        if (this.multitaskingElements.progressBars && this.multitaskingElements.progressBars.length > 0) {
            this.multitaskingElements.progressBars.forEach(bar => {
                const container = bar.closest('.ug-ai-nas__super-smooth-multitasking-content-number-content-number-line-container');
                
                if (container) {
                    container.addEventListener('mouseenter', () => {
                        gsap.to(bar, {
                            boxShadow: '0 0 20px rgba(89, 163, 237, 0.5)',
                            duration: 0.3,
                            ease: "power2.out"
                        });
                    });

                    container.addEventListener('mouseleave', () => {
                        gsap.to(bar, {
                            boxShadow: '0 0 0px rgba(89, 163, 237, 0)',
                            duration: 0.3,
                            ease: "power2.out"
                        });
                    });
                }
            });
        }
        
        // Super-Smooth Multitasking interactions added
     },

     /**
      * 初始化AI智能对话功能模块 - 支持视频播放控制
      */
     initIntelligentConversationFeatures() {
         if (!this.elements.intelligentConversationImageSwiper || !this.elements.intelligentConversationTitleSwiper) return;

         let imageSwiper, titleSwiper;

         // 视频相关变量
         this.currentActiveVideo = null;
         this.isIntelligentConversationVisible = false;

         // 更新导航按钮显示状态
         const updateNavigationVisibility = (swiper) => {
             const prevButton = document.querySelector('.ug-ai-nas__conversation-titles-prev');
             const nextButton = document.querySelector('.ug-ai-nas__conversation-titles-next');
             
             if (prevButton) {
                 prevButton.style.display = swiper.isBeginning ? 'none' : 'flex';
             }
             
             if (nextButton) {
                 nextButton.style.display = swiper.isEnd ? 'none' : 'flex';
             }
         };

         // 更新活动标题样式
         const updateActiveTitle = (index) => {
             if (!this.elements.intelligentConversationTitles) return;
             
             this.elements.intelligentConversationTitles.forEach((title, i) => {
                 if (i === index) {
                     title.classList.add('active');
                 } else {
                     title.classList.remove('active');
                 }
             });

             // 更新描述的显示状态
             const desItems = document.querySelectorAll('.ug-ai-nas__intelligent-conversation-des-item');
             if (desItems) {
                 desItems.forEach((item, i) => {
                     if (i === index) {
                         item.classList.add('active');
                     } else {
                         item.classList.remove('active');
                     }
                 });
             }
         };

         // 初始化视频功能
         this.initIntelligentConversationVideos();

         // 初始化图片轮播
         imageSwiper = new Swiper(this.elements.intelligentConversationImageSwiper, {
             slidesPerView: 1,
             spaceBetween: 20,
             speed: 1000,
             allowTouchMove: false,
             preventInteractionOnTransition: true,
             effect: 'slide',
             on: {
                 slideChange: function() {
                     const currentIndex = this.activeIndex;
                     updateActiveTitle(currentIndex);
                     // 处理视频切换逻辑
                     // 需要通过外部引用调用方法，因为这里的this指向swiper
                     const ugaiNas = document.ugaiNasInstance || window.UGAINas;
                     if (ugaiNas && ugaiNas.handleVideoSlideChange) {
                         ugaiNas.handleVideoSlideChange(currentIndex);
                     }
                 }
             }
         });

         // 保存swiper实例
         this.intelligentConversationImageSwiper = imageSwiper;

         // 初始化标题轮播
         titleSwiper = new Swiper(this.elements.intelligentConversationTitleSwiper, {
             slidesPerView: 'auto',
             spaceBetween: 20,
             speed: 800,
             watchSlidesProgress: true,
             preventInteractionOnTransition: false,
             slideToClickedSlide: false,
             touchRatio: 1,
             navigation: {
                 nextEl: '.ug-ai-nas__conversation-titles-next',
                 prevEl: '.ug-ai-nas__conversation-titles-prev',
             },
             breakpoints: {
                 768: {
                     spaceBetween: 36,
                 }
             },
             on: {
                 init: function() {
                     updateNavigationVisibility(this);
                 },
                 slideChange: function() {
                     updateNavigationVisibility(this);
                 }
             }
         });

         // 点击标题切换图片和更新状态
         if (this.elements.intelligentConversationTitles) {
             this.elements.intelligentConversationTitles.forEach((title, index) => {
                 title.addEventListener('click', () => {
                     // 切换图片
                     imageSwiper.slideTo(index);
                     // 更新标题高亮状态和描述显示
                     updateActiveTitle(index);
                     // 滚动标题到对应位置
                     titleSwiper.slideTo(index);
                     // 处理视频切换逻辑
                     this.handleVideoTitleClick(index);
                 });
             });
         }

         // 初始化滚动监听
         this.initIntelligentConversationScrollTrigger();
         
         // 初始化中心触发器
         this.initIntelligentConversationCenterTrigger();

         // 初始化第一个标题和描述为活动状态
         updateActiveTitle(0);
         this.handleVideoSlideChange(0);

         // 已移除图片hover效果
     },

     /**
      * 初始化智能对话视频功能
      */
     initIntelligentConversationVideos() {
         if (!this.elements.intelligentConversationVideos.length) return;

         // 为每个视频添加事件监听
         this.elements.intelligentConversationVideos.forEach((video, index) => {
             // 播放事件
             video.addEventListener('play', () => {
                 this.handleVideoPlay(video, index);
             });

             // 暂停事件
             video.addEventListener('pause', () => {
                 this.handleVideoPause(video, index);
             });

             // 结束事件
             video.addEventListener('ended', () => {
                 this.handleVideoEnded(video, index);
             });

             // 时间更新事件（用于检测重置到第一帧）
             video.addEventListener('timeupdate', () => {
                 this.handleVideoTimeUpdate(video, index);
             });
         });

         // 为每个控制按钮添加点击事件
         this.elements.intelligentConversationVideoControls.forEach((control, index) => {
             control.addEventListener('click', (e) => {
                 e.stopPropagation();
                 this.toggleVideoPlayback(index);
             });
         });
     },

     /**
      * 处理视频播放事件
      */
     handleVideoPlay(video, index) {
         const control = this.elements.intelligentConversationVideoControls[index];
         const overlay = this.elements.intelligentConversationVideoOverlays[index];
         
         if (control) {
             const playIcon = control.querySelector('.ug-ai-nas-new-play-icon');
             const pauseIcon = control.querySelector('.ug-ai-nas-new-pause-icon');
             const replayIcon = control.querySelector('.ug-ai-nas-new-replay-icon');
             if (playIcon) playIcon.style.display = 'none';
             if (pauseIcon) pauseIcon.style.display = 'block';
             if (replayIcon) replayIcon.style.display = 'none';
         }
         
         if (overlay) {
             overlay.classList.add('hidden');
         }
     },

     /**
      * 处理视频暂停事件
      */
     handleVideoPause(video, index) {
         const control = this.elements.intelligentConversationVideoControls[index];
         
         if (control) {
             const playIcon = control.querySelector('.ug-ai-nas-new-play-icon');
             const pauseIcon = control.querySelector('.ug-ai-nas-new-pause-icon');
             const replayIcon = control.querySelector('.ug-ai-nas-new-replay-icon');
             if (playIcon) playIcon.style.display = 'block';
             if (pauseIcon) pauseIcon.style.display = 'none';
             if (replayIcon) replayIcon.style.display = 'none';
         }
     },

     /**
      * 处理视频结束事件
      */
     handleVideoEnded(video, index) {
         const control = this.elements.intelligentConversationVideoControls[index];
         const overlay = this.elements.intelligentConversationVideoOverlays[index];
         
         video.currentTime = 0;
         
         if (control) {
             const playIcon = control.querySelector('.ug-ai-nas-new-play-icon');
             const pauseIcon = control.querySelector('.ug-ai-nas-new-pause-icon');
             const replayIcon = control.querySelector('.ug-ai-nas-new-replay-icon');
             if (playIcon) playIcon.style.display = 'none';
             if (pauseIcon) pauseIcon.style.display = 'none';
             if (replayIcon) replayIcon.style.display = 'block';
         }
         
         if (overlay) {
             overlay.classList.remove('hidden');
         }
     },

     /**
      * 处理视频时间更新事件
      */
     handleVideoTimeUpdate(video, index) {
         // 检测是否重置到第一帧
         if (video.currentTime === 0 && !video.paused) {
             const overlay = this.elements.intelligentConversationVideoOverlays[index];
             if (overlay) {
                 overlay.classList.remove('hidden');
             }
         }
     },

     /**
      * 切换视频播放状态
      */
     toggleVideoPlayback(index) {
         const video = this.elements.intelligentConversationVideos[index];
         if (!video) return;

         if (video.paused) {
             video.play().catch(error => {
                 // 静默处理视频播放失败
             });
         } else {
             video.pause();
         }
     },

     /**
      * 处理滑块切换时的视频逻辑
      */
     handleVideoSlideChange(activeIndex) {
         // 暂停所有视频并重置到第一帧
         this.pauseAllIntelligentConversationVideos();
         
         // 显示所有遮罩
         this.showAllIntelligentConversationOverlays();
         
         // 如果模块在视觉范围内，播放当前活动视频
         if (this.isIntelligentConversationVisible) {
             const activeVideo = this.elements.intelligentConversationVideos[activeIndex];
             if (activeVideo) {
                 this.currentActiveVideo = activeVideo;
                 setTimeout(() => {
                     activeVideo.play().catch(error => {
                         // 静默处理视频播放失败
                     });
                 }, 100);
             }
         }
     },

     /**
      * 处理标题点击时的视频逻辑
      */
     handleVideoTitleClick(index) {
         // 暂停所有视频并重置到第一帧
         this.pauseAllIntelligentConversationVideos();
         
         // 显示所有遮罩
         this.showAllIntelligentConversationOverlays();
         
         // 点击标题时直接播放对应视频，不依赖可见性状态
         const activeVideo = this.elements.intelligentConversationVideos[index];
         if (activeVideo) {
             this.currentActiveVideo = activeVideo;
             setTimeout(() => {
                 activeVideo.play().catch(error => {
                     // 静默处理视频播放失败
                 });
             }, 100);
         }
     },

     /**
      * 暂停所有智能对话视频
      */
     pauseAllIntelligentConversationVideos() {
         this.elements.intelligentConversationVideos.forEach(video => {
             if (!video.paused) {
                 video.pause();
             }
             video.currentTime = 0;
         });
     },

     /**
      * 显示所有智能对话视频遮罩
      */
     showAllIntelligentConversationOverlays() {
         this.elements.intelligentConversationVideoOverlays.forEach(overlay => {
             overlay.classList.remove('hidden');
         });
         
         // 重置所有控制按钮到播放状态
         this.elements.intelligentConversationVideoControls.forEach(control => {
             const playIcon = control.querySelector('.ug-ai-nas-new-play-icon');
             const pauseIcon = control.querySelector('.ug-ai-nas-new-pause-icon');
             const replayIcon = control.querySelector('.ug-ai-nas-new-replay-icon');
             if (playIcon) playIcon.style.display = 'block';
             if (pauseIcon) pauseIcon.style.display = 'none';
             if (replayIcon) replayIcon.style.display = 'none';
         });
     },

     /**
      * 初始化智能对话模块的滚动监听
      */
     initIntelligentConversationScrollTrigger() {
         if (!this.elements.intelligentConversationSection) return;

         // 监听模块中心是否在视觉范围内
         ScrollTrigger.create({
             trigger: this.elements.intelligentConversationSection,
             start: "top 80%",
             end: "bottom 20%",
             // 只设置可见性状态，不播放视频
             onEnter: () => {
                 this.isIntelligentConversationVisible = true;
             },
             onLeave: () => {
                 this.isIntelligentConversationVisible = false;
                 this.handleIntelligentConversationLeaveView();
             },
             // 只设置可见性状态，不播放视频
             onEnterBack: () => {
                 this.isIntelligentConversationVisible = true;
             },
             onLeaveBack: () => {
                 this.isIntelligentConversationVisible = false;
                 this.handleIntelligentConversationLeaveView();
             }
         });

         // 监听图片模块中心是否在视觉范围内
         const imageSlider = document.querySelector('.ug-ai-nas__intelligent-conversation-slider');
         if (imageSlider) {
             ScrollTrigger.create({
                 trigger: imageSlider,
                 start: "center 60%",
                 end: "center 40%",
                 onEnter: () => {
                     this.handleImageSliderCenterView();
                 },
                 onEnterBack: () => {
                     this.handleImageSliderCenterView();
                 }
             });
         }
     },

     /**
      * 处理智能对话模块进入视觉范围
      */
     handleIntelligentConversationEnterView() {
         // 如果有当前活动的滑块，播放对应视频
         if (this.intelligentConversationImageSwiper) {
             const activeIndex = this.intelligentConversationImageSwiper.activeIndex;
             const activeVideo = this.elements.intelligentConversationVideos[activeIndex];
             if (activeVideo) {
                 this.currentActiveVideo = activeVideo;
                 activeVideo.play().catch(error => {
                     // 静默处理视频播放失败
                 });
             }
         }
     },

     /**
      * 处理智能对话模块离开视觉范围
      */
     handleIntelligentConversationLeaveView() {
         // 暂停当前活动视频
         if (this.currentActiveVideo && !this.currentActiveVideo.paused) {
             this.currentActiveVideo.pause();
         }
     },

     /**
      * 处理图片滑块到达中心视觉位置
      */
     handleImageSliderCenterView() {
         if (this.isIntelligentConversationVisible && this.intelligentConversationImageSwiper) {
             const activeIndex = this.intelligentConversationImageSwiper.activeIndex;
             const activeVideo = this.elements.intelligentConversationVideos[activeIndex];
             if (activeVideo && activeVideo.paused) {
                 activeVideo.play().catch(error => {
                     // 静默处理视频播放失败
                 });
             }
         }
     },

     /**
      * 精确的中心触发器
      */
     createCenterTrigger() {
         // 查找 intelligentConversationImageSwiper 元素作为精确触发器
         const imageSwiper = document.querySelector('.ug-ai-nas__intelligent-conversation-content .intelligentConversationImageSwiper') 
                          || document.querySelector('.intelligentConversationImageSwiper');
         
         if (!imageSwiper) {
             // intelligentConversationImageSwiper element not found
             return;
         }

         // 精确的中心对齐 ScrollTrigger - 触发视频播放
         ScrollTrigger.create({
             trigger: imageSwiper,
             start: "center center",
             end: "+=50vh",
             markers: false, // 生产环境关闭标记
             onEnter: () => {
                 this.handleIntelligentConversationEnterView();
             },
             onEnterBack: () => {
                 this.handleIntelligentConversationEnterView();
             }
         });
     },

     /**
      * 初始化智能对话中心触发器
      */
     initIntelligentConversationCenterTrigger() {
         this.createCenterTrigger();
     },

     // 留邮箱
    
};

// =====================================
// Specs Comparison Module
// =====================================

/**
 * 规格对比配置 - 以对象形式管理参数数据
 */
const SpecsComparison = {
    // 配置项
    config: {
        defaultVisibleRows: 3, // 默认显示行数
    },
    spacesProData:[
        {
            "proName":"iDX6011",
            "proImage":"https://cdn.shopify.com/s/files/1/0630/9416/1602/files/iDX6011_1.png?v=1750404269",
            "proDesc":"Ultra-Capable Smart Storage.",
            "proSpectKey": "idx6011"
        },
        {
            "proName":"iDX6011 Pro",
            "proImage":"https://cdn.shopify.com/s/files/1/0630/9416/1602/files/iDX6011-Pro_1.png?v=1750404269",
            "proDesc":"The Ultimate in NAS Performance.",
            "proSpectKey": "idx6011Pro"
        }
    ],
    // 规格数据 - 使用对象形式便于管理
    specsData: [
        {
            category: "Processor",
            values: {
                idx6011: ["Intel Core Ultra 5 125H", "14 Cores 18 Threads", "34 TOPS*"],
                idx6011Pro: ["Intel Core Ultra 7 255H", "16 Cores 16 Threads", "96 TOPS"]
            }
        },
        {
            category: "RAM",
            values: {
                idx6011: ["32GB/64GB LPDDR5/x"],
                idx6011Pro: ["64GB LPDDR5/x"]
            }
        },
        {
            category: "Maximum Storage",
            values: {
                idx6011: ["196TB\\30TB x6 + 8TB x2"],
                idx6011Pro: ["196TB\\30TB x6 + 8TB x2"]
            }
        },
        {
            category: "SATA Drive Bays",
            values: {
                idx6011: ["x6"],
                idx6011Pro: ["x6"]
            }
        },
        {
            category: "System Drive Capacity",
            values: {
                idx6011: ["SSD 128GB"],
                idx6011Pro: ["SSD 128GB"]
            }
        },
        {
            category: "M.2 SSD Drive Slots",
            values: {
                idx6011: ["2"],
                idx6011Pro: ["2"]
            }
        },
        {
            category: "Operating Systems",
            values: {
                idx6011: ["UGOS"],
                idx6011Pro: ["UGOS"]
            }
        },
        {
            category: "RAID",
            values: {
                idx6011: ["JBOD/Basic/RAID 0/1/5/6/10"],
                idx6011Pro: ["JBOD/Basic/RAID 0/1/5/6/10"]
            }
        },
        {
            category: "LAN Ports",
            values: {
                idx6011: ["10GbE x2"],
                idx6011Pro: ["10GbE x2"]
            }
        },
        {
            category: "USB 3.2",
            values: {
                idx6011: ["x2"],
                idx6011Pro: ["x2"]
            }
        },
        {
            category: "USB 2.0",
            values: {
                idx6011: ["x2"],
                idx6011Pro: ["x2"]
            }
        },
        {
            category: "Thunderbolt™ 4",
            values: {
                idx6011: ["40Gb/s x2"],
                idx6011Pro: ["40Gb/s x2"]
            }
        },
        {
            category: "PCIe Expansion",
            values: {
                idx6011: ["X8 x1"],
                idx6011Pro: ["X8 x1"]
            }
        },
        {
            category: "OCuLink Port",
            values: {
                idx6011: ["-"],
                idx6011Pro: ["x1"]
            }
        },
        {
            category: "SD Card Slot",
            values: {
                idx6011: ["4.0 x1"],
                idx6011Pro: ["4.0 x1"]
            }
        },
        {
            category: "HDMI",
            values: {
                idx6011: ["8K"],
                idx6011Pro: ["8K"]
            }
        },
        {
            category: "LCD Display",
            values: {
                idx6011: ["-"],
                idx6011Pro: ["3.0\""]
            }
        },
        {
            category: "UPS Support",
            values: {
                idx6011: ["Yes"],
                idx6011Pro: ["Yes"]
            }
        },
        {
            category: "Docker Support",
            values: {
                idx6011: ["Yes"],
                idx6011Pro: ["Yes"]
            }
        }
    ],

    // 状态管理
    state: {
        isExpanded: false,
        specsHeaderElement: null,
        specsListElement: null,
        toggleButton: null,
        visibleRows: 3
    },

    /**
     * 初始化规格对比模块
     */
    init() {
        this.state.specsHeaderElement = document.getElementById('specsHeader');
        this.state.specsListElement = document.getElementById('specsList');
        this.state.toggleButton = document.getElementById('specsToggleBtn');
        
        if (!this.state.specsListElement || !this.state.toggleButton) {
            return;
        }

        // 初始化状态className
        const specsCard = document.querySelector('.ug-ai-nas__specs-card');
        if (specsCard) {
            specsCard.classList.add('collapsed'); // 默认为收起状态
        }

        this.renderSpecs();
        this.setupToggleButton();
        this.initializeHeight();
    },
    /**
     * 渲染规格列表
     */
    renderSpecs() {
        this.state.specsHeaderElement.innerHTML = '';
        let headerHtml = '';
        headerHtml = headerHtml + `<div class="ug-ai-nas__specs-label"></div> 
                        <div class="ug-ai-nas__specs-products">`;
        this.spacesProData.forEach(product => {
            headerHtml = headerHtml + `<div class="ug-ai-nas__specs-product">
                                        <div class="ug-ai-nas__specs-product-image">
                                           <img src="${product.proImage}" alt="${product.proName}">
                                        </div>
                                        <div class="ug-ai-nas__specs-product-info">
                                            <h3 class="ug-ai-nas__specs-product-name">${product.proName}</h3>
                                            <p class="ug-ai-nas__specs-product-desc">${product.proDesc}</p>
                                        </div>
                                    </div>`;
        });

        headerHtml = headerHtml + `</div>
                                </div>`;
        this.state.specsHeaderElement.insertAdjacentHTML('beforeend', headerHtml);

        this.state.specsListElement.innerHTML = '';
        // 生成规格对比行
        this.specsData.forEach((spec, index) => {
            const isHidden = index >= this.config.defaultVisibleRows ? 'ug-ai-nas__specs-row-hidden' : '';
            
            let rowHtml = `<div class="ug-ai-nas__specs-row ${isHidden}" data-row-index="${index}">
                            <div class="ug-ai-nas__specs-category ug-ai-nas-pc">${spec.category}</div>
                                <div class="ug-ai-nas__specs-values">
                                <p class="ug-ai-nas__specs-category ug-ai-nas-mobile">${spec.category}</p>
                                <div class="ug-ai-nas__specs-cont">`;
                                
            // 遍历产品数据生成对应的规格值
            this.spacesProData.forEach(product => {
                const specKey = product.proSpectKey; // idx6011 或 idx6011Pro
                const specValues = spec.values[specKey] || ['-'];

                rowHtml += `<div class="ug-ai-nas__specs-column">`;
                specValues.forEach(value => {
                    rowHtml += `<p class="ug-ai-nas__specs-value">${value.replace('\\', '/')}</p>`;
                });
                rowHtml += `</div>`;
            });
            
            rowHtml += '</div></div></div>';
            
            // 插入规格行
            this.state.specsListElement.insertAdjacentHTML('beforeend', rowHtml);
        });
    },

    /**
     * 设置切换按钮
     */
    setupToggleButton() {
        this.state.toggleButton.addEventListener('click', () => {
            this.toggleSpecs();
        });
    },

    /**
     * 初始化容器高度 - 类似 liquid 页面的逻辑
     */
    initializeHeight() {
        const specsList = this.state.specsListElement;
        
        // 设置初始状态：显示默认行数
        this.updateRowVisibility();
        
        // 计算初始高度并设置
        this.setActiveMaxHeight();
    },

    /**
     * 更新行的可见性
     */
    updateRowVisibility() {
        const rows = this.state.specsListElement.querySelectorAll('.ug-ai-nas__specs-row');
        
        rows.forEach((row, index) => {
            if (this.state.isExpanded || index < this.state.visibleRows) {
                row.classList.remove('hidden');
            } else {
                row.classList.add('hidden');
            }
        });
    },

    /**
     * 设置容器的最大高度 - 类似 liquid 页面的 activeMaxHeightFn
     */
    setActiveMaxHeight() {
        const specsList = this.state.specsListElement;
        
        if (specsList) {
            specsList.style.maxHeight = specsList.scrollHeight + "px";
        }
    },



    /**
     * 切换展开/收起状态
     */
    toggleSpecs() {
        this.state.isExpanded = !this.state.isExpanded;
        
        // 添加状态className到card
        const specsCard = document.querySelector('.ug-ai-nas__specs-card');
        if (specsCard) {
            if (this.state.isExpanded) {
                specsCard.classList.add('expanded');
                specsCard.classList.remove('collapsed');
            } else {
                specsCard.classList.add('collapsed');
                specsCard.classList.remove('expanded');
            }
        }
        
        this.updateVisibility();
        this.updateToggleButton();
    },

    /**
     * 更新可见性 - 类似 liquid 页面的展开收起逻辑
     */
    updateVisibility() {
        const specsList = this.state.specsListElement;
        
        if (this.state.isExpanded) {
            // 展开状态：先更新行可见性，然后设置高度
            this.updateRowVisibility();
            this.setActiveMaxHeight();
        } else {
            // 收起状态：先设置高度为null，然后更新行可见性
            if (specsList.style.maxHeight) {
                specsList.style.maxHeight = null;
            }
            this.updateRowVisibility();
            // 延迟设置高度以确保过渡效果
            setTimeout(() => {
                this.setActiveMaxHeight();
            }, 50);
        }
        
        // 刷新ScrollTrigger
        setTimeout(() => {
            if (typeof ScrollTrigger !== 'undefined') {
                ScrollTrigger.refresh();
            }
        }, 450);
    },

    /**
     * 更新切换按钮状态
     */
    updateToggleButton() {
        const toggleText = this.state.toggleButton.querySelector('.ug-ai-nas__specs-toggle-text');
        const toggleIcon = this.state.toggleButton.querySelector('.ug-ai-nas__specs-toggle-icon');

        if (this.state.isExpanded) {
            toggleText.textContent = 'Show less';
            this.state.toggleButton.classList.add('expanded');
        } else {
            toggleText.textContent = 'Show more';
            this.state.toggleButton.classList.remove('expanded');
        }
    },





    /**
     * 设置显示行数
     * @param {number} rows - 要显示的行数
     */
    setVisibleRows(rows) {
        this.state.visibleRows = Math.max(1, rows);
        this.updateVisibility();
    },

    /**
     * 获取当前显示行数
     * @returns {number} 当前显示的行数
     */
    getVisibleRows() {
        return this.state.visibleRows;
    },

    /**
     * 添加新的规格数据
     * @param {Object} specData - 规格数据对象
     */
    addSpec(specData) {
        this.specsData.push(specData);
        this.renderSpecs();
        setTimeout(() => {
            this.updateRowVisibility();
            this.setActiveMaxHeight();
        }, 50);
    },

    /**
     * 更新规格数据
     * @param {number} index - 要更新的规格索引
     * @param {Object} specData - 新的规格数据
     */
    updateSpec(index, specData) {
        if (index >= 0 && index < this.specsData.length) {
            this.specsData[index] = specData;
            this.renderSpecs();
            setTimeout(() => {
                this.updateRowVisibility();
                this.setActiveMaxHeight();
            }, 50);
        }
    },

    /**
     * 移除规格数据
     * @param {number} index - 要移除的规格索引
     */
    removeSpec(index) {
        if (index >= 0 && index < this.specsData.length) {
            this.specsData.splice(index, 1);
            this.renderSpecs();
            setTimeout(() => {
                this.updateRowVisibility();
                this.setActiveMaxHeight();
            }, 50);
        }
    }
};

// 等待所有依赖库加载完成的函数
function waitForDependencies() {
    return new Promise((resolve) => {
        const checkDependencies = () => {
            // 检查所有必需的依赖库
            const dependencies = {
                gsap: window.gsap,
                ScrollTrigger: window.ScrollTrigger,
                Swiper: window.Swiper
            };
            
            const missingDeps = Object.keys(dependencies).filter(dep => !dependencies[dep]);
            
            if (missingDeps.length === 0) {
            resolve();
        } else {
                setTimeout(checkDependencies, 100);
            }
        };
        
        checkDependencies();
    });
}

// 检查页面是否完全加载（包括图片等资源）
function waitForPageReady() {
    return new Promise((resolve) => {
        if (document.readyState === 'complete') {
            resolve();
        } else {
            const checkReady = () => {
                if (document.readyState === 'complete') {
                    resolve();
                } else {
                    setTimeout(checkReady, 100);
                }
            };
            
            // 监听load事件作为备选
            window.addEventListener('load', resolve, { once: true });
            checkReady();
        }
    });
}

// 检查页面可见性
function checkPageVisibility() {
    return new Promise((resolve) => {
        if (document.visibilityState === 'visible') {
            resolve();
        } else {
            const handleVisibilityChange = () => {
                if (document.visibilityState === 'visible') {
                    document.removeEventListener('visibilitychange', handleVisibilityChange);
                    resolve();
                }
            };
            document.addEventListener('visibilitychange', handleVisibilityChange);
        }
    });
}

// 增强的初始化系统
class InitializationManagerDE {
    constructor() {
        this.isInitialized = false;
        this.initPromise = null;
        this.retryCount = 0;
        this.maxRetries = 3;
    }

    async initialize() {
        if (this.isInitialized) {
            return;
        }

        if (this.initPromise) {
            return this.initPromise;
        }

        this.initPromise = this._doInitialize();
        return this.initPromise;
    }

    async _doInitialize() {
        try {
            // 步骤1: 等待所有依赖库加载
            await waitForDependencies();
            
            // 步骤2: 等待页面完全加载
            await waitForPageReady();
            
            // 步骤3: 等待页面可见
            await checkPageVisibility();
            
            // 步骤4: 注册GSAP插件
            if (window.gsap && window.ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
            }
            
            // 步骤5: 初始化应用
            await this._initializeApp();
            
            // 步骤6: 设置重新初始化监听器
            this._setupReinitializationListeners();
            
            this.isInitialized = true;
            
        } catch (error) {
            await this._handleInitializationError();
        } finally {
            this.initPromise = null;
        }
    }

    async _initializeApp() {
        // 确保在下一帧开始初始化，给浏览器时间完成渲染
        await new Promise(resolve => requestAnimationFrame(resolve));
        
        // 初始化主应用
        UGreenAINAS.init();
        
        // 初始化规格对比模块
        SpecsComparison.init();
        
        // DE版本主应用组件已初始化
    }

    async _handleInitializationError() {
        this.retryCount++;
        
        if (this.retryCount <= this.maxRetries) {
            await new Promise(resolve => setTimeout(resolve, 1000 * this.retryCount));
            return this.initialize();
        } else {
            // 显示用户友好的错误提示
            this._showRetryButton();
        }
    }

    _setupReinitializationListeners() {
        // 监听页面可见性变化，处理标签页切换场景
        let visibilityTimeout;
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                // 页面变为可见时，延迟检查并重新初始化必要组件
                clearTimeout(visibilityTimeout);
                visibilityTimeout = setTimeout(() => {
                    this._reinitializeIfNeeded();
                }, 500);
            }
        });

        // 监听窗口焦点事件
        let focusTimeout;
        window.addEventListener('focus', () => {
            clearTimeout(focusTimeout);
            focusTimeout = setTimeout(() => {
                this._reinitializeIfNeeded();
            }, 300);
        });

        // 监听滚动停止事件，处理早期滚动导致的动画失效
        let scrollTimeout;
        const handleScroll = () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                this._checkAndRefreshAnimations();
            }, 500);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });

        // 监听窗口大小变化，重新计算ScrollTrigger位置
        let resizeTimeout;
        const handleResize = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                // 窗口大小变化，刷新ScrollTrigger
                if (window.ScrollTrigger) {
                    ScrollTrigger.refresh();
                    // 延迟检查关键动画状态
                    setTimeout(() => {
                        this._checkCriticalAnimations();
                    }, 300);
                }
            }, 300);
        };
        window.addEventListener('resize', handleResize, { passive: true });
    }

    _reinitializeIfNeeded() {
        if (!this.isInitialized) return;

        // 检查是否需要重新初始化组件

        // 检查关键DOM元素是否存在
        const keyElements = [
            '.idx-nas-new-pc-nav',
            '.idx-nas-new-mobile-nav',
            '.ug-ai-nas__features-image-swiper',
            '.ug-ai-nas__features-title-swiper'
        ];

        const missingElements = keyElements.filter(selector => !document.querySelector(selector));
        
        if (missingElements.length > 0) {
            // 发现缺失的关键元素，跳过重新初始化
            return;
        }

        // 检查Swiper实例是否正常工作
        if (this._checkSwiperInstances()) {
            // 重新初始化Swiper
            this._reinitializeSwipers();
        }

        // 刷新ScrollTrigger
        if (window.ScrollTrigger) {
            ScrollTrigger.refresh();
            // ScrollTrigger已刷新
        }
    }

    _checkSwiperInstances() {
        const swiperElements = document.querySelectorAll('.swiper');
        let needsReinit = false;

        swiperElements.forEach(element => {
            if (element.swiper && !element.swiper.destroyed) {
                // Swiper实例存在且未销毁，检查是否正常工作
                try {
                    element.swiper.update();
                } catch (error) {
                    // Swiper实例异常
                    needsReinit = true;
                }
            } else {
                needsReinit = true;
            }
        });

        return needsReinit;
    }

    _reinitializeSwipers() {
        // 重新初始化Swiper组件
        
        // 销毁现有的Swiper实例
        document.querySelectorAll('.swiper').forEach(element => {
            if (element.swiper && !element.swiper.destroyed) {
                element.swiper.destroy(true, true);
            }
        });

        // 重新初始化Swiper
        if (UGreenAINAS && typeof UGreenAINAS.initSwipers === 'function') {
            setTimeout(() => {
                UGreenAINAS.initSwipers();
                // Swiper组件已重新初始化
            }, 100);
        }
    }

    _checkAndRefreshAnimations() {
        if (!this.isInitialized || !window.ScrollTrigger) return;

        // 检查ScrollTrigger实例数量
        const triggers = ScrollTrigger.getAll();
        if (triggers.length === 0) {
            // 重新初始化动画
            if (UGreenAINAS && typeof UGreenAINAS.initAnimations === 'function') {
                setTimeout(() => {
                    UGreenAINAS.initAnimations();
                }, 100);
            }
        } else {
            // 检查关键模块的动画状态
            this._checkCriticalAnimations();
        }
    }

    /**
     * 检查关键动画模块的状态
     */
    _checkCriticalAnimations() {
        // 检查Fast Data Transfer区域
        this._checkFastDataTransferAnimations();
        
        // 检查Simplified Setup区域
        this._checkSimplifiedSetupAnimations();
    }

    /**
     * 检查Fast Data Transfer动画状态
     */
    _checkFastDataTransferAnimations() {
        const fastSection = document.querySelector('.ug-ai-nas__fast-data-transfer-section');
        if (!fastSection) return;

        const containers = fastSection.querySelectorAll('.ug-ai-nas__fast-data-transfer-container');
        if (!containers.length) return;

        // 检查是否在视口内且动画未触发
        containers.forEach((container, index) => {
            const rect = container.getBoundingClientRect();
            const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
            
            if (isInViewport) {
                // 检查是否已经有动画状态
                const subtitle = container.querySelector('.ug-ai-nas__fast-data-transfer-content-subtitle');
                if (subtitle) {
                    const computedStyle = window.getComputedStyle(subtitle);
                    const hasAnimation = computedStyle.opacity !== '0' || computedStyle.transform !== 'none';
                    
                    if (!hasAnimation) {
                        // 重新触发Fast Data Transfer动画
                        this._reinitializeFastDataTransfer(container);
                    }
                }
            }
        });
    }

    /**
     * 重新初始化Fast Data Transfer动画
     */
    _reinitializeFastDataTransfer(container) {
        if (!UGreenAINAS || typeof UGreenAINAS.setFastDataTransferInitialState !== 'function') return;

        try {
            // 重新设置初始状态
            UGreenAINAS.setFastDataTransferInitialState(container);
            
            // 延迟触发动画
            setTimeout(() => {
                if (typeof UGreenAINAS.animateFastDataTransferContainer === 'function') {
                    UGreenAINAS.animateFastDataTransferContainer(container);
                }
            }, 300);
        } catch (error) {
            // 静默处理重新初始化错误
        }
    }

    /**
     * 检查Simplified Setup动画状态
     */
    _checkSimplifiedSetupAnimations() {
        const setupSection = document.querySelector('.ug-ai-nas__simplified-setup-container');
        if (!setupSection) return;

        const rect = setupSection.getBoundingClientRect();
        const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;

        if (isInViewport) {
            // 检查主要元素的动画状态
            const mainElement = setupSection.querySelector('.ug-ai-nas__simplified-setup-main');
            if (mainElement) {
                const computedStyle = window.getComputedStyle(mainElement);
                const hasAnimation = computedStyle.opacity !== '0' || computedStyle.transform !== 'none';
                
                if (!hasAnimation) {
                    // 重新触发Simplified Setup动画
                    this._reinitializeSimplifiedSetup();
                }
            }
        }
    }

    /**
     * 重新初始化Simplified Setup动画
     */
    _reinitializeSimplifiedSetup() {
        if (!UGreenAINAS || typeof UGreenAINAS.initSimplifiedSetupAnimations !== 'function') return;

        try {
            // 刷新ScrollTrigger位置计算
            ScrollTrigger.refresh();
            
            // 延迟重新初始化
            setTimeout(() => {
                UGreenAINAS.initSimplifiedSetupAnimations();
            }, 300);
        } catch (error) {
            // 静默处理重新初始化错误
        }
    }

    _showRetryButton() {
        // 创建重试按钮
        const retryButton = document.createElement('div');
        retryButton.innerHTML = `
            <div style="
                position: fixed;
                top: 20px;
                right: 20px;
                background: #ff6b6b;
                color: white;
                padding: 12px 20px;
                border-radius: 8px;
                cursor: pointer;
                font-family: Arial, sans-serif;
                font-size: 14px;
                font-weight: bold;
                box-shadow: 0 4px 12px rgba(0,0,0,0.3);
                z-index: 10000;
                user-select: none;
            ">
                Seitenfehler, Klicken Sie hier zum Wiederholen
            </div>
        `;
        
        retryButton.addEventListener('click', () => {
            window.location.reload();
        });
        
        document.body.appendChild(retryButton);
        
        // 5秒后自动隐藏
        setTimeout(() => {
            if (retryButton.parentNode) {
                retryButton.parentNode.removeChild(retryButton);
            }
        }, 5000);
    }

    // 手动重置初始化状态的方法
    reset() {
        this.isInitialized = false;
        this.initPromise = null;
        this.retryCount = 0;
        // DE版本初始化状态已重置
    }
}

// 创建全局初始化管理器实例
const initManagerDE = new InitializationManagerDE();

// 多重初始化策略
const initializeAppDE = async () => {
    try {
        await initManagerDE.initialize();
    } catch (error) {
        // 静默处理初始化失败
    }
};

// 主初始化逻辑 - 多事件监听确保初始化
if (document.readyState === 'loading') {
    // 页面还在加载中
    document.addEventListener('DOMContentLoaded', initializeAppDE);
    window.addEventListener('load', initializeAppDE);
} else if (document.readyState === 'interactive') {
    // DOM已加载但资源可能还在加载
    window.addEventListener('load', initializeAppDE);
    // 也立即尝试初始化
    setTimeout(initializeAppDE, 100);
} else {
    // 页面已完全加载
    setTimeout(initializeAppDE, 100);
}

// 提供全局方法供调试使用
window.UGreenNASInitDE = {
    reinitialize: () => initManagerDE.initialize(),
    reset: () => initManagerDE.reset(),
    status: () => ({
        isInitialized: initManagerDE.isInitialized,
        retryCount: initManagerDE.retryCount,
        scrollTriggers: ScrollTrigger ? ScrollTrigger.getAll().length : 0
    }),

};

// 兼容原有的等待函数（保持向后兼容）
function waitForGSAP() {
    return waitForDependencies();
} 

 